window.reparacoesData = {
  "galaxy-z-flip4": {
    "Reparações disponíveis": [
      { nome: "Display/Touch", preco: "429,90€" },
      { nome: "Bateria", preco: "Sob consulta" },
      { nome: "Conector de Carga", preco: "Sob consulta" },
      { nome: "Câmara frontal", preco: "Sob consulta" },
      { nome: "Câmara Traseira", preco: "Sob consulta" },
      { nome: "Tampa Traseira", preco: "Sob consulta" },
      { nome: "Descreve a avaria", preco: "Sob consulta" }
    ]
  },
  "galaxy-z-flip3": {
    "Reparações disponíveis": [
      { nome: "Display/Touch", preco: "389,90€" },
      { nome: "Bateria", preco: "Sob consulta" },
      { nome: "Conector de Carga", preco: "74,90€" },
      { nome: "Câmara frontal", preco: "Sob consulta" },
      { nome: "Câmara Traseira", preco: "Sob consulta" },
      { nome: "Tampa Traseira", preco: "94,90€" },
      { nome: "Descreve a avaria", preco: "Sob consulta" }
    ]
  },
  "galaxy-z-flip": {
    "Reparações disponíveis": [
      { nome: "Display/Touch", preco: "54,90€" },
      { nome: "Bateria", preco: "Sob consulta" },
      { nome: "Conector de Carga", preco: "Sob consulta" },
      { nome: "Câmara frontal", preco: "Sob consulta" },
      { nome: "Câmara Traseira", preco: "Sob consulta" },
      { nome: "Tampa Traseira", preco: "Sob consulta" },
      { nome: "Descreve a avaria", preco: "Sob consulta" }
    ]
  },
  "galaxy-z-fold4": {
    "Reparações disponíveis": [
      { nome: "Display/Touch", preco: "Sob consulta" },
      { nome: "Bateria", preco: "Sob consulta" },
      { nome: "Conector de Carga", preco: "Sob consulta" },
      { nome: "Câmara frontal", preco: "Sob consulta" },
      { nome: "Câmara Traseira", preco: "109,90€" },
      { nome: "Tampa Traseira", preco: "109,90€" },
      { nome: "Descreve a avaria", preco: "Sob consulta" }
    ]
  },
  "galaxy-z-fold3": {
    "Reparações disponíveis": [
      { nome: "Display/Touch", preco: "589,90€" },
      { nome: "Bateria", preco: "Sob consulta" },
      { nome: "Conector de Carga", preco: "69,90€" },
      { nome: "Câmara frontal", preco: "Sob consulta" },
      { nome: "Câmara Traseira", preco: "99,90€" },
      { nome: "Tampa Traseira", preco: "99,90€" },
      { nome: "Descreve a avaria", preco: "Sob consulta" }
    ]
  },
  "galaxy-z-fold2": {
    "Reparações disponíveis": [
      { nome: "Display/Touch", preco: "479,90€" },
      { nome: "Bateria", preco: "Sob consulta" },
      { nome: "Conector de Carga", preco: "Sob consulta" },
      { nome: "Câmara frontal", preco: "Sob consulta" },
      { nome: "Câmara Traseira", preco: "Sob consulta" },
      { nome: "Tampa Traseira", preco: "79,90€" },
      { nome: "Descreve a avaria", preco: "Sob consulta" }
    ]
  },
  "galaxy-z-fold": {
    "Reparações disponíveis": []
  },
  "galaxy-s23-ultra": {
    "Reparações disponíveis": [
      { nome: "Display/Touch", preco: "379,90€" },
      { nome: "Bateria", preco: "49,90€" },
      { nome: "Conector de Carga", preco: "64,90€" },
      { nome: "Câmara frontal", preco: "109,90€" },
      { nome: "Câmara Traseira", preco: "159,90€" },
      { nome: "Tampa Traseira", preco: "79,90€" },
      { nome: "Descreve a avaria", preco: "Sob consulta" }
    ]
  },
  "galaxy-s23-plus": {
    "Reparações disponíveis": [
      { nome: "Display/Touch", preco: "329,90€" },
      { nome: "Bateria", preco: "49,90€" },
      { nome: "Conector de Carga", preco: "Sob consulta" },
      { nome: "Câmara frontal", preco: "89,90€" },
      { nome: "Câmara Traseira", preco: "Sob consulta" },
      { nome: "Tampa Traseira", preco: "79,90€" },
      { nome: "Descreve a avaria", preco: "Sob consulta" }
    ]
  },
  "galaxy-s23": {
    "Reparações disponíveis": [
      { nome: "Display/Touch", preco: "289,90€" },
      { nome: "Bateria", preco: "49,90€" },
      { nome: "Conector de Carga", preco: "Sob consulta" },
      { nome: "Câmara frontal", preco: "89,90€" },
      { nome: "Câmara Traseira", preco: "Sob consulta" },
      { nome: "Tampa Traseira", preco: "79,90€" },
      { nome: "Descreve a avaria", preco: "Sob consulta" }
    ]
  },
  "galaxy-s22-ultra": {
    "Reparações disponíveis": [
      { nome: "Display/Touch", preco: "329,90€" },
      { nome: "Bateria", preco: "Sob consulta" },
      { nome: "Conector de Carga", preco: "Sob consulta" },
      { nome: "Câmara frontal", preco: "Sob consulta" },
      { nome: "Câmara Traseira", preco: "Sob consulta" },
      { nome: "Tampa Traseira", preco: "Sob consulta" },
      { nome: "Descreve a avaria", preco: "Sob consulta" }
    ]
  },
  "galaxy-s22-plus": {
    "Reparações disponíveis": [
      { nome: "Display/Touch", preco: "229,90€" },
      { nome: "Bateria", preco: "Sob consulta" },
      { nome: "Conector de Carga", preco: "Sob consulta" },
      { nome: "Câmara frontal", preco: "Sob consulta" },
      { nome: "Câmara Traseira", preco: "Sob consulta" },
      { nome: "Tampa Traseira", preco: "69,90€" },
      { nome: "Descreve a avaria", preco: "Sob consulta" }
    ]
  },
  "galaxy-s22": {
    "Reparações disponíveis": [
      { nome: "Display/Touch", preco: "229,90€" },
      { nome: "Bateria", preco: "Sob consulta" },
      { nome: "Conector de Carga", preco: "Sob consulta" },
      { nome: "Câmara frontal", preco: "Sob consulta" },
      { nome: "Câmara Traseira", preco: "Sob consulta" },
      { nome: "Tampa Traseira", preco: "69,90€" },
      { nome: "Descreve a avaria", preco: "Sob consulta" }
    ]
  },
  "galaxy-s21-ultra": {
    "Reparações disponíveis": [
      { nome: "Display/Touch", preco: "349,90€" },
      { nome: "Bateria", preco: "49,90€" },
      { nome: "Conector de Carga", preco: "49,90€" },
      { nome: "Câmara frontal", preco: "74,90€" },
      { nome: "Câmara Traseira", preco: "139,90€" },
      { nome: "Tampa Traseira", preco: "69,90€" },
      { nome: "Descreve a avaria", preco: "Sob consulta" }
    ]
  },
  "galaxy-s21-plus": {
    "Reparações disponíveis": [
      { nome: "Display/Touch", preco: "189,90€" },
      { nome: "Bateria", preco: "49,90€" },
      { nome: "Conector de Carga", preco: "89,90€" },
      { nome: "Câmara frontal", preco: "69,90€" },
      { nome: "Câmara Traseira", preco: "119,90€" },
      { nome: "Tampa Traseira", preco: "69,90€" },
      { nome: "Descreve a avaria", preco: "Sob consulta" }
    ]
  },
  "galaxy-s21": {
    "Reparações disponíveis": [
      { nome: "Display/Touch", preco: "189,90€" },
      { nome: "Bateria", preco: "49,90€" },
      { nome: "Conector de Carga", preco: "49,90€" },
      { nome: "Câmara frontal", preco: "69,90€" },
      { nome: "Câmara Traseira", preco: "119,90€" },
      { nome: "Tampa Traseira", preco: "69,90€" },
      { nome: "Descreve a avaria", preco: "Sob consulta" }
    ]
  },
  "galaxy-s20-ultra": {
    "Reparações disponíveis": [
      { nome: "Display/Touch", preco: "289,90€" },
      { nome: "Bateria", preco: "49,90€" },
      { nome: "Conector de Carga", preco: "69,90€" },
      { nome: "Câmara frontal", preco: "Sob consulta" },
      { nome: "Câmara Traseira", preco: "129,90€" },
      { nome: "Tampa Traseira", preco: "Sob consulta" },
      { nome: "Descreve a avaria", preco: "Sob consulta" }
    ]
  },
  "galaxy-s20-plus": {
    "Reparações disponíveis": [
      { nome: "Display/Touch", preco: "289,90€" },
      { nome: "Bateria", preco: "49,90€" },
      { nome: "Conector de Carga", preco: "59,90€" },
      { nome: "Câmara frontal", preco: "Sob consulta" },
      { nome: "Câmara Traseira", preco: "129,90€" },
      { nome: "Tampa Traseira", preco: "79,90€" },
      { nome: "Descreve a avaria", preco: "Sob consulta" }
    ]
  },
  "galaxy-s20": {
    "Reparações disponíveis": [
      { nome: "Display/Touch", preco: "229,90€" },
      { nome: "Bateria", preco: "49,90€" },
      { nome: "Conector de Carga", preco: "54,90€" },
      { nome: "Câmara frontal", preco: "59,90€" },
      { nome: "Câmara Traseira", preco: "Sob consulta" },
      { nome: "Tampa Traseira", preco: "69,90€" },
      { nome: "Descreve a avaria", preco: "Sob consulta" }
    ]
  },
  "galaxy-s20-fe": {
    "Reparações disponíveis": [
      { nome: "Display/Touch", preco: "169,90€" },
      { nome: "Bateria", preco: "49,90€" },
      { nome: "Conector de Carga", preco: "Sob consulta" },
      { nome: "Câmara frontal", preco: "Sob consulta" },
      { nome: "Câmara Traseira", preco: "Sob consulta" },
      { nome: "Tampa Traseira", preco: "59,90€" },
      { nome: "Descreve a avaria", preco: "Sob consulta" }
    ]
  },
  "galaxy-s10-plus": {
    "Reparações disponíveis": [
      { nome: "Display/Touch", preco: "259,90€" },
      { nome: "Bateria", preco: "49,90€" },
      { nome: "Conector de Carga", preco: "Sob consulta" },
      { nome: "Câmara frontal", preco: "59,90€" },
      { nome: "Câmara Traseira", preco: "89,90€" },
      { nome: "Tampa Traseira", preco: "49,90€" },
      { nome: "Descreve a avaria", preco: "Sob consulta" }
    ]
  },
  "galaxy-s10": {
    "Reparações disponíveis": [
      { nome: "Display/Touch", preco: "219,90€" },
      { nome: "Bateria", preco: "49,90€" },
      { nome: "Conector de Carga", preco: "Sob consulta" },
      { nome: "Câmara frontal", preco: "Sob consulta" },
      { nome: "Câmara Traseira", preco: "89,90€" },
      { nome: "Tampa Traseira", preco: "49,90€" },
      { nome: "Descreve a avaria", preco: "Sob consulta" }
    ]
  },
  "galaxy-s10e": {
    "Reparações disponíveis": [
      { nome: "Display/Touch", preco: "179,90€" },
      { nome: "Bateria", preco: "49,90€" },
      { nome: "Conector de Carga", preco: "39,90€" },
      { nome: "Câmara frontal", preco: "59,90€" },
      { nome: "Câmara Traseira", preco: "89,90€" },
      { nome: "Tampa Traseira", preco: "49,90€" },
      { nome: "Descreve a avaria", preco: "Sob consulta" }
    ]
  },
  "galaxy-s10-lite": {
    "Reparações disponíveis": [
      { nome: "Display/Touch", preco: "269,90€" },
      { nome: "Bateria", preco: "49,90€" },
      { nome: "Conector de Carga", preco: "Sob consulta" },
      { nome: "Câmara frontal", preco: "Sob consulta" },
      { nome: "Câmara Traseira", preco: "Sob consulta" },
      { nome: "Tampa Traseira", preco: "49,90€" },
      { nome: "Descreve a avaria", preco: "Sob consulta" }
    ]
  },
  "galaxy-s9-plus": {
    "Reparações disponíveis": [
      { nome: "Display/Touch", preco: "169,90€" },
      { nome: "Bateria", preco: "49,90€" },
      { nome: "Conector de Carga", preco: "69,90€" },
      { nome: "Câmara frontal", preco: "Sob consulta" },
      { nome: "Câmara Traseira", preco: "79,90€" },
      { nome: "Tampa Traseira", preco: "49,90€" },
      { nome: "Descreve a avaria", preco: "Sob consulta" }
    ]
  },
  "galaxy-s9": {
    "Reparações disponíveis": [
      { nome: "Display/Touch", preco: "169,90€" },
      { nome: "Bateria", preco: "49,90€" },
      { nome: "Conector de Carga", preco: "49,90€" },
      { nome: "Câmara frontal", preco: "49,90€" },
      { nome: "Câmara Traseira", preco: "49,90€" },
      { nome: "Tampa Traseira", preco: "49,90€" },
      { nome: "Descreve a avaria", preco: "Sob consulta" }
    ]
  },
  "galaxy-a54": {
    "Reparações disponíveis": [
      { nome: "Display/Touch", preco: "Sob consulta" },
      { nome: "Bateria", preco: "Sob consulta" },
      { nome: "Conector de Carga", preco: "Sob consulta" },
      { nome: "Câmara frontal", preco: "Sob consulta" },
      { nome: "Câmara Traseira", preco: "Sob consulta" },
      { nome: "Tampa Traseira", preco: "Sob consulta" },
      { nome: "Descreve a avaria", preco: "Sob consulta" }
    ]
  },
  "galaxy-a24-4g": {
    "Reparações disponíveis": [
      { nome: "Display/Touch", preco: "Sob consulta" },
      { nome: "Bateria", preco: "Sob consulta" },
      { nome: "Conector de Carga", preco: "Sob consulta" },
      { nome: "Câmara frontal", preco: "Sob consulta" },
      { nome: "Câmara Traseira", preco: "Sob consulta" },
      { nome: "Tampa Traseira", preco: "Sob consulta" },
      { nome: "Descreve a avaria", preco: "Sob consulta" }
    ]
  },
  "galaxy-a34-5g": {
    "Reparações disponíveis": [
      { nome: "Display/Touch", preco: "129,90€" },
      { nome: "Bateria", preco: "Sob consulta" },
      { nome: "Conector de Carga", preco: "49,90€" },
      { nome: "Câmara frontal", preco: "54,90€" },
      { nome: "Câmara Traseira", preco: "Sob consulta" },
      { nome: "Tampa Traseira", preco: "Sob consulta" },
      { nome: "Descreve a avaria", preco: "Sob consulta" }
    ]
  },
  "galaxy-a34": {
    "Reparações disponíveis": [
      { nome: "Display/Touch", preco: "Sob consulta" },
      { nome: "Bateria", preco: "Sob consulta" },
      { nome: "Conector de Carga", preco: "Sob consulta" },
      { nome: "Câmara frontal", preco: "Sob consulta" },
      { nome: "Câmara Traseira", preco: "Sob consulta" },
      { nome: "Tampa Traseira", preco: "Sob consulta" },
      { nome: "Descreve a avaria", preco: "Sob consulta" }
    ]
  },
  "galaxy-a14-5g": {
    "Reparações disponíveis": [
      { nome: "Display/Touch", preco: "89,90€" },
      { nome: "Bateria", preco: "Sob consulta" },
      { nome: "Conector de Carga", preco: "Sob consulta" },
      { nome: "Câmara frontal", preco: "Sob consulta" },
      { nome: "Câmara Traseira", preco: "Sob consulta" },
      { nome: "Tampa Traseira", preco: "Sob consulta" },
      { nome: "Descreve a avaria", preco: "Sob consulta" }
    ]
  },
  "galaxy-a14": {
    "Reparações disponíveis": [
      { nome: "Display/Touch", preco: "69,90€" },
      { nome: "Bateria", preco: "Sob consulta" },
      { nome: "Conector de Carga", preco: "44,90€" },
      { nome: "Câmara frontal", preco: "Sob consulta" },
      { nome: "Câmara Traseira", preco: "Sob consulta" },
      { nome: "Tampa Traseira", preco: "44,90€" },
      { nome: "Descreve a avaria", preco: "Sob consulta" }
    ]
  },
  "galaxy-a04e": {
    "Reparações disponíveis": [
      { nome: "Display/Touch", preco: "Sob consulta" },
      { nome: "Bateria", preco: "Sob consulta" },
      { nome: "Conector de Carga", preco: "Sob consulta" },
      { nome: "Câmara frontal", preco: "Sob consulta" },
      { nome: "Câmara Traseira", preco: "Sob consulta" },
      { nome: "Tampa Traseira", preco: "Sob consulta" },
      { nome: "Descreve a avaria", preco: "Sob consulta" }
    ]
  },
  "galaxy-a04s": {
    "Reparações disponíveis": [
      { nome: "Display/Touch", preco: "64,90€" },
      { nome: "Bateria", preco: "49,90€" },
      { nome: "Conector de Carga", preco: "44,90€" },
      { nome: "Câmara frontal", preco: "Sob consulta" },
      { nome: "Câmara Traseira", preco: "Sob consulta" },
      { nome: "Tampa Traseira", preco: "Sob consulta" },
      { nome: "Descreve a avaria", preco: "Sob consulta" }
    ]
  },
  "galaxy-a23-5g": {
    "Reparações disponíveis": [
      { nome: "Display/Touch", preco: "89,90€" },
      { nome: "Bateria", preco: "Sob consulta" },
      { nome: "Conector de Carga", preco: "49,90€" },
      { nome: "Câmara frontal", preco: "Sob consulta" },
      { nome: "Câmara Traseira", preco: "Sob consulta" },
      { nome: "Tampa Traseira", preco: "Sob consulta" },
      { nome: "Descreve a avaria", preco: "Sob consulta" }
    ]
  },
  "galaxy-a73-5g": {
    "Reparações disponíveis": [
      { nome: "Display/Touch", preco: "139,90€" },
      { nome: "Bateria", preco: "Sob consulta" },
      { nome: "Conector de Carga", preco: "Sob consulta" },
      { nome: "Câmara frontal", preco: "Sob consulta" },
      { nome: "Câmara Traseira", preco: "Sob consulta" },
      { nome: "Tampa Traseira", preco: "Sob consulta" },
      { nome: "Descreve a avaria", preco: "Sob consulta" }
    ]
  },
  "galaxy-a53-5g": {
    "Reparações disponíveis": [
      { nome: "Display/Touch", preco: "139,90€" },
      { nome: "Bateria", preco: "49,90€" },
      { nome: "Conector de Carga", preco: "49,90€" },
      { nome: "Câmara frontal", preco: "49,90€" },
      { nome: "Câmara Traseira", preco: "Sob consulta" },
      { nome: "Tampa Traseira", preco: "Sob consulta" },
      { nome: "Descreve a avaria", preco: "Sob consulta" }
    ]
  },
  "galaxy-a33-5g": {
    "Reparações disponíveis": [
      { nome: "Display/Touch", preco: "109,90€" },
      { nome: "Bateria", preco: "49,90€" },
      { nome: "Conector de Carga", preco: "49,90€" },
      { nome: "Câmara frontal", preco: "54,90€" },
      { nome: "Câmara Traseira", preco: "Sob consulta" },
      { nome: "Tampa Traseira", preco: "Sob consulta" },
      { nome: "Descreve a avaria", preco: "Sob consulta" }
    ]
  },
  "galaxy-a23": {
    "Reparações disponíveis": [
      { nome: "Display/Touch", preco: "89,90€" },
      { nome: "Tampa Traseira", preco: "59,90€" },
      { nome: "Conector de Carga", preco: "Sob consulta" },
      { nome: "Câmara frontal", preco: "Sob consulta" },
      { nome: "Câmara Traseira", preco: "Sob consulta" },
      { nome: "Descreve a avaria", preco: "Sob consulta" }
    ]
  },
  "galaxy-a13-5g": {
    "Reparações disponíveis": [
      { nome: "Display/Touch", preco: "69,90€" },
      { nome: "Bateria", preco: "49,90€" },
      { nome: "Conector de Carga", preco: "44,90€" },
      { nome: "Câmara frontal", preco: "Sob consulta" },
      { nome: "Câmara Traseira", preco: "Sob consulta" },
      { nome: "Tampa Traseira", preco: "44,90€" },
      { nome: "Descreve a avaria", preco: "Sob consulta" }
    ]
  },
  "galaxy-a13": {
    "Reparações disponíveis": [
      { nome: "Display/Touch", preco: "69,90€" },
      { nome: "Bateria", preco: "Sob consulta" },
      { nome: "Conector de Carga", preco: "44,90€" },
      { nome: "Câmara frontal", preco: "44,90€" },
      { nome: "Câmara Traseira", preco: "Sob consulta" },
      { nome: "Tampa Traseira", preco: "44,90€" },
      { nome: "Descreve a avaria", preco: "Sob consulta" }
    ]
  },
  "galaxy-a03": {
    "Reparações disponíveis": [
      { nome: "Display/Touch", preco: "69,90€" },
      { nome: "Bateria", preco: "49,90€" },
      { nome: "Conector de Carga", preco: "44,90€" },
      { nome: "Câmara frontal", preco: "Sob consulta" },
      { nome: "Câmara Traseira", preco: "Sob consulta" },
      { nome: "Tampa Traseira", preco: "Sob consulta" },
      { nome: "Descreve a avaria", preco: "Sob consulta" }
    ]
  },
  "galaxy-a03s": {
    "Reparações disponíveis": [
      { nome: "Display/Touch", preco: "64,90€" },
      { nome: "Bateria", preco: "49,90€" },
      { nome: "Conector de Carga", preco: "44,90€" },
      { nome: "Câmara frontal", preco: "39,90€" },
      { nome: "Câmara Traseira", preco: "39,90€" },
      { nome: "Descreve a avaria", preco: "Sob consulta" }
    ]
  },
  "galaxy-a22-5g": {
    "Reparações disponíveis": [
      { nome: "Display/Touch", preco: "89,90€" },
      { nome: "Bateria", preco: "49,90€" },
      { nome: "Conector de Carga", preco: "44,90€" },
      { nome: "Câmara frontal", preco: "Sob consulta" },
      { nome: "Câmara Traseira", preco: "Sob consulta" },
      { nome: "Tampa Traseira", preco: "59,90€" },
      { nome: "Descreve a avaria", preco: "Sob consulta" }
    ]
  },
  "galaxy-a52-5g": {
    "Reparações disponíveis": [
      { nome: "Display/Touch", preco: "129,90€" },
      { nome: "Bateria", preco: "Sob consulta" },
      { nome: "Conector de Carga", preco: "54,90€" },
      { nome: "Câmara frontal", preco: "49,90€" },
      { nome: "Câmara Traseira", preco: "Sob consulta" },
      { nome: "Tampa Traseira", preco: "Sob consulta" },
      { nome: "Descreve a avaria", preco: "Sob consulta" }
    ]
  },
  "galaxy-a32-5g": {
    "Reparações disponíveis": [
      { nome: "Display/Touch", preco: "89,90€" },
      { nome: "Bateria", preco: "49,90€" },
      { nome: "Conector de Carga", preco: "49,90€" },
      { nome: "Câmara frontal", preco: "Sob consulta" },
      { nome: "Câmara Traseira", preco: "Sob consulta" },
      { nome: "Tampa Traseira", preco: "Sob consulta" },
      { nome: "Descreve a avaria", preco: "Sob consulta" }
    ]
  },
  "galaxy-a02": {
    "Reparações disponíveis": [
      { nome: "Display/Touch", preco: "69,90€" },
      { nome: "Bateria", preco: "Sob consulta" },
      { nome: "Conector de Carga", preco: "Sob consulta" },
      { nome: "Câmara frontal", preco: "Sob consulta" },
      { nome: "Câmara Traseira", preco: "Sob consulta" },
      { nome: "Tampa Traseira", preco: "Sob consulta" },
      { nome: "Descreve a avaria", preco: "Sob consulta" }
    ]
  },
  "galaxy-a72": {
    "Reparações disponíveis": [
      { nome: "Display/Touch", preco: "119,90€" },
      { nome: "Bateria", preco: "Sob consulta" },
      { nome: "Conector de Carga", preco: "Sob consulta" },
      { nome: "Câmara frontal", preco: "Sob consulta" },
      { nome: "Câmara Traseira", preco: "Sob consulta" },
      { nome: "Tampa Traseira", preco: "Sob consulta" },
      { nome: "Descreve a avaria", preco: "Sob consulta" }
    ]
  },
  "galaxy-a52s": {
    "Reparações disponíveis": [
      { nome: "Display/Touch", preco: "129,90€" },
      { nome: "Bateria", preco: "Sob consulta" },
      { nome: "Conector de Carga", preco: "Sob consulta" },
      { nome: "Câmara frontal", preco: "Sob consulta" },
      { nome: "Câmara Traseira", preco: "Sob consulta" },
      { nome: "Tampa Traseira", preco: "Sob consulta" },
      { nome: "Descreve a avaria", preco: "Sob consulta" }
    ]
  },
  "galaxy-a52": {
    "Reparações disponíveis": [
      { nome: "Display/Touch", preco: "129,90€" },
      { nome: "Bateria", preco: "49,90€" },
      { nome: "Conector de Carga", preco: "Sob consulta" },
      { nome: "Câmara frontal", preco: "Sob consulta" },
      { nome: "Câmara Traseira", preco: "Sob consulta" },
      { nome: "Tampa Traseira", preco: "Sob consulta" },
      { nome: "Descreve a avaria", preco: "Sob consulta" }
    ]
  },
  "galaxy-a32": {
    "Reparações disponíveis": [
      { nome: "Display/Touch", preco: "89,90€" },
      { nome: "Bateria", preco: "49,90€" },
      { nome: "Conector de Carga", preco: "Sob consulta" },
      { nome: "Câmera frontal", preco: "Sob consulta" },
      { nome: "Câamera Traseira", preco: "Sob consulta" },
      { nome: "Tampa Traseira", preco: "Sob consulta" },
      { nome: "Descreve a avaria", preco: "Sob consulta" }
    ]
  },
  "galaxy-a22": {
    "Reparações disponíveis": [
      { nome: "Display/Touch", preco: "89,90€" },
      { nome: "Bateria", preco: "49,90€" },
      { nome: "Conector de Carga", preco: "Sob consulta" },
      { nome: "Câamera frontal", preco: "Sob consulta" },
      { nome: "Câamera Traseira", preco: "Sob consulta" },
      { nome: "Tampa Traseira", preco: "Sob consulta" },
      { nome: "Descreve a avaria", preco: "Sob consulta" }
    ]
  },
  "galaxy-a42-5g": {
    "Reparações disponíveis": [
      { nome: "Display/Touch", preco: "89,90€" },
      { nome: "Bateria", preco: "49,90€" },
      { nome: "Conector de Carga", preco: "49,90€" },
      { nome: "Câmera frontal", preco: "64,90€" },
      { nome: "Câamera Traseira", preco: "Sob consulta" },
      { nome: "Tampa Traseira", preco: "Sob consulta" },
      { nome: "Descreve a avaria", preco: "Sob consulta" }
    ]
  },
  "galaxy-a71-5g": {
    "Reparações disponíveis": [
      { nome: "Display/Touch", preco: "149,90€" },
      { nome: "Bateria", preco: "Sob consulta" },
      { nome: "Conector de Carga", preco: "Sob consulta" },
      { nome: "Câamera frontal", preco: "Sob consulta" },
      { nome: "Câamera Traseira", preco: "Sob consulta" },
      { nome: "Tampa Traseira", preco: "Sob consulta" },
      { nome: "Descreve a avaria", preco: "Sob consulta" }
    ]
  },
  "galaxy-a51-5g": {
    "Reparações disponíveis": [
      { nome: "Display/Touch", preco: "129,90€" },
      { nome: "Bateria", preco: "Sob consulta" },
      { nome: "Conector de Carga", preco: "Sob consulta" },
      { nome: "Câamera frontal", preco: "Sob consulta" },
      { nome: "Câamera Traseira", preco: "59,90€" },
      { nome: "Tampa Traseira", preco: "49,90€" },
      { nome: "Descreve a avaria", preco: "Sob consulta" }
    ]
  },
  "galaxy-a21": {
    "Reparações disponíveis": [
      { nome: "Display/Touch", preco: "Sob consulta" },
      { nome: "Bateria", preco: "Sob consulta" },
      { nome: "Conector de Carga", preco: "Sob consulta" },
      { nome: "Câamera frontal", preco: "Sob consulta" },
      { nome: "Câamera Traseira", preco: "Sob consulta" },
      { nome: "Tampa Traseira", preco: "Sob consulta" },
      { nome: "Descreve a avaria", preco: "Sob consulta" }
    ]
  },
  "galaxy-a11": {
    "Reparações disponíveis": [
      { nome: "Display/Touch", preco: "69,90€" },
      { nome: "Bateria", preco: "49,90€" },
      { nome: "Conector de Carga", preco: "39,90€" },
      { nome: "Câamera frontal", preco: "Sob consulta" },
      { nome: "Câamera Traseira", preco: "Sob consulta" },
      { nome: "Tampa Traseira", preco: "Sob consulta" },
      { nome: "Descreve a avaria", preco: "Sob consulta" }
    ]
  },
  "galaxy-a71": {
    "Reparações disponíveis": [
      { nome: "Display/Touch", preco: "109,90€" },
      { nome: "Bateria", preco: "49,90€" },
      { nome: "Conector de Carga", preco: "Sob consulta" },
      { nome: "Câamera frontal", preco: "Sob consulta" },
      { nome: "Câamera Traseira", preco: "Sob consulta" },
      { nome: "Tampa Traseira", preco: "Sob consulta" },
      { nome: "Descreve a avaria", preco: "Sob consulta" }
    ]
  },
  "galaxy-a51": {
    "Reparações disponíveis": [
      { nome: "Display/Touch", preco: "109,90€" },
      { nome: "Bateria", preco: "49,90€" },
      { nome: "Conector de Carga", preco: "Sob consulta" },
      { nome: "Câamera frontal", preco: "Sob consulta" },
      { nome: "Câamera Traseira", preco: "Sob consulta" },
      { nome: "Tampa Traseira", preco: "Sob consulta" },
      { nome: "Descreve a avaria", preco: "Sob consulta" }
    ]
  },
  "galaxy-a42": {
    "Reparações disponíveis": [
      { nome: "Display/Touch", preco: "89,90€" },
      { nome: "Bateria", preco: "Sob consulta" },
      { nome: "Conector de Carga", preco: "Sob consulta" },
      { nome: "Câamera frontal", preco: "Sob consulta" },
      { nome: "Câamera Traseira", preco: "Sob consulta" },
      { nome: "Tampa Traseira", preco: "Sob consulta" },
      { nome: "Descreve a avaria", preco: "Sob consulta" }
    ]
  },
  "galaxy-a41": {
    "Reparações disponíveis": [
      { nome: "Display/Touch", preco: "99,90€" },
      { nome: "Bateria", preco: "49,90€" },
      { nome: "Conector de Carga", preco: "Sob consulta" },
      { nome: "Câamera frontal", preco: "Sob consulta" },
      { nome: "Câamera Traseira", preco: "Sob consulta" },
      { nome: "Tampa Traseira", preco: "Sob consulta" },
      { nome: "Descreve a avaria", preco: "Sob consulta" }
    ]
  },
  "galaxy-a31": {
    "Reparações disponíveis": [
      { nome: "Display/Touch", preco: "89,90€" },
      { nome: "Bateria", preco: "49,90€" },
      { nome: "Conector de Carga", preco: "Sob consulta" },
      { nome: "Câamera frontal", preco: "Sob consulta" },
      { nome: "Câamera Traseira", preco: "Sob consulta" },
      { nome: "Tampa Traseira", preco: "Sob consulta" },
      { nome: "Descreve a avaria", preco: "Sob consulta" }
    ]
  },
  "galaxy-a21s": {
    "Reparações disponíveis": [
      { nome: "Display/Touch", preco: "79,90€" },
      { nome: "Bateria", preco: "49,90€" },
      { nome: "Conector de Carga", preco: "44,90€" },
      { nome: "Câamera frontal", preco: "79,90€" },
      { nome: "Câamera Traseira", preco: "79,90€" },
      { nome: "Tampa Traseira", preco: "69,90€" },
      { nome: "Descreve a avaria", preco: "Sob consulta" }
    ]
  },
  "galaxy-a12": {
    "Reparações disponíveis": [
      { nome: "Display/Touch", preco: "69,90€" },
      { nome: "Bateria", preco: "Sob consulta" },
      { nome: "Conector de Carga", preco: "Sob consulta" },
      { nome: "Câmera frontal", preco: "Sob consulta" },
      { nome: "Câmera Traseira", preco: "Sob consulta" },
      { nome: "Tampa Traseira", preco: "Sob consulta" },
      { nome: "Descreve a avaria", preco: "Sob consulta" }
    ]
  },
  "galaxy-a02s": {
    "Reparações disponíveis": [
      { nome: "Display/Touch", preco: "59,90€" },
      { nome: "Bateria", preco: "Sob consulta" },
      { nome: "Conector de Carga", preco: "Sob consulta" },
      { nome: "Câmera frontal", preco: "Sob consulta" },
      { nome: "Câmera Traseira", preco: "Sob consulta" },
      { nome: "Tampa Traseira", preco: "Sob consulta" },
      { nome: "Descreve a avaria", preco: "Sob consulta" }
    ]
  },
  "galaxy-a01": {
    "Reparações disponíveis": [
      { nome: "Display/Touch", preco: "49,90€" },
      { nome: "Conector de Carga", preco: "39,90€" },
      { nome: "Conector de Carga", preco: "Sob consulta" },
      { nome: "Câmera frontal", preco: "Sob consulta" },
      { nome: "Câmera Traseira", preco: "Sob consulta" },
      { nome: "Tampa Traseira", preco: "Sob consulta" },
      { nome: "Descreve a avaria", preco: "Sob consulta" }
    ]
  },
  "galaxy-a70s": {
    "Reparações disponíveis": [
      { nome: "Display/Touch", preco: "Sob consulta" },
      { nome: "Bateria", preco: "Sob consulta" },
      { nome: "Conector de Carga", preco: "Sob consulta" },
      { nome: "Câmera frontal", preco: "Sob consulta" },
      { nome: "Câmera Traseira", preco: "Sob consulta" },
      { nome: "Tampa Traseira", preco: "Sob consulta" },
      { nome: "Descreve a avaria", preco: "Sob consulta" }
    ]
  },
  "galaxy-a90-5g": {
    "Reparações disponíveis": [
      { nome: "Display/Touch", preco: "Sob consulta" },
      { nome: "Bateria", preco: "Sob consulta" },
      { nome: "Conector de Carga", preco: "Sob consulta" },
      { nome: "Câmera frontal", preco: "Sob consulta" },
      { nome: "Câmera Traseira", preco: "Sob consulta" },
      { nome: "Tampa Traseira", preco: "Sob consulta" },
      { nome: "Descreve a avaria", preco: "Sob consulta" }
    ]
  },
  "galaxy-a50s": {
    "Reparações disponíveis": [
      { nome: "Display/Touch", preco: "109,90€" },
      { nome: "Bateria", preco: "Sob consulta" },
      { nome: "Conector de Carga", preco: "49,90€" },
      { nome: "Câmera frontal", preco: "Sob consulta" },
      { nome: "Câmera Traseira", preco: "Sob consulta" },
      { nome: "Tampa Traseira", preco: "Sob consulta" },
      { nome: "Descreve a avaria", preco: "Sob consulta" }
    ]
  },
  "galaxy-a10e": {
    "Reparações disponíveis": [
      { nome: "Display/Touch", preco: "Sob consulta" },
      { nome: "Bateria", preco: "Sob consulta" },
      { nome: "Conector de Carga", preco: "49,90€" },
      { nome: "Câmera frontal", preco: "Sob consulta" },
      { nome: "Câmera Traseira", preco: "Sob consulta" },
      { nome: "Tampa Traseira", preco: "Sob consulta" },
      { nome: "Descreve a avaria", preco: "Sob consulta" }
    ]
  },
  "galaxy-a80": {
    "Reparações disponíveis": [
      { nome: "Display/Touch", preco: "119,90€" },
      { nome: "Bateria", preco: "49,90€" },
      { nome: "Conector de Carga", preco: "Sob consulta" },
      { nome: "Câamera frontal", preco: "Sob consulta" },
      { nome: "Câamera Traseira", preco: "Sob consulta" },
      { nome: "Tampa Traseira", preco: "Sob consulta" },
      { nome: "Descreve a avaria", preco: "Sob consulta" }
    ]
  },
  "galaxy-a70": {
    "Reparações disponíveis": [
      { nome: "Display/Touch", preco: "109,90€" },
      { nome: "Bateria", preco: "49,90€" },
      { nome: "Conector de Carga", preco: "59,90€" },
      { nome: "Câamera frontal", preco: "Sob consulta" },
      { nome: "Câamera Traseira", preco: "59,90€" },
      { nome: "Tampa Traseira", preco: "49,90€" },
      { nome: "Descreve a avaria", preco: "Sob consulta" }
    ]
  },
  "galaxy-a50": {
    "Reparações disponíveis": [
      { nome: "Display/Touch", preco: "89,90€" },
      { nome: "Bateria", preco: "49,90€" },
      { nome: "Conector de Carga", preco: "49,90€" },
      { nome: "Câamera frontal", preco: "59,90€" },
      { nome: "Câamera Traseira", preco: "Sob consulta" },
      { nome: "Tampa Traseira", preco: "Sob consulta" },
      { nome: "Descreve a avaria", preco: "Sob consulta" }
    ]
  },
  "galaxy-a40": {
    "Reparações disponíveis": [
      { nome: "Display/Touch", preco: "89,90€" },
      { nome: "Bateria", preco: "49,90€" },
      { nome: "Conector de Carga", preco: "49,90€" },
      { nome: "Câamera frontal", preco: "59,90€" },
      { nome: "Câamera Traseira", preco: "Sob consulta" },
      { nome: "Tampa Traseira", preco: "Sob consulta" },
      { nome: "Descreve a avaria", preco: "Sob consulta" }
    ]
  },
  "galaxy-a30s": {
    "Reparações disponíveis": [
      { nome: "Display/Touch", preco: "89,90€" },
      { nome: "Bateria", preco: "49,90€" },
      { nome: "Conector de Carga", preco: "Sob consulta" },
      { nome: "Câmera frontal", preco: "Sob consulta" },
      { nome: "Câamera Traseira", preco: "Sob consulta" },
      { nome: "Tampa Traseira", preco: "Sob consulta" },
      { nome: "Descreve a avaria", preco: "Sob consulta" }
    ]
  },
  "galaxy-a30": {
    "Reparações disponíveis": [
      { nome: "Display/Touch", preco: "89,90€" },
      { nome: "Bateria", preco: "49,90€" },
      { nome: "Conector de Carga", preco: "Sob consulta" },
      { nome: "Câamera frontal", preco: "Sob consulta" },
      { nome: "Câamera Traseira", preco: "Sob consulta" },
      { nome: "Tampa Traseira", preco: "Sob consulta" },
      { nome: "Descreve a avaria", preco: "Sob consulta" }
    ]
  },
  "galaxy-a20e": {
    "Reparações disponíveis": [
      { nome: "Display/Touch", preco: "69,90€" },
      { nome: "Bateria", preco: "49,90€" },
      { nome: "Conector de Carga", preco: "49,90€" },
      { nome: "Câamera frontal", preco: "Sob consulta" },
      { nome: "Câamera Traseira", preco: "Sob consulta" },
      { nome: "Tampa Traseira", preco: "Sob consulta" },
      { nome: "Descreve a avaria", preco: "Sob consulta" }
    ]
  },
  "galaxy-a20s": {
    "Reparações disponíveis": [
      { nome: "Display/Touch", preco: "69,90€" },
      { nome: "Bateria", preco: "49,90€" },
      { nome: "Conector de Carga", preco: "Sob consulta" },
      { nome: "Câamera frontal", preco: "Sob consulta" },
      { nome: "Câamera Traseira", preco: "Sob consulta" },
      { nome: "Tampa Traseira", preco: "Sob consulta" },
      { nome: "Descreve a avaria", preco: "Sob consulta" }
    ]
  },
  "galaxy-a20": {
    "Reparações disponíveis": [
      { nome: "Display/Touch", preco: "69,90€" },
      { nome: "Bateria", preco: "49,90€" },
      { nome: "Conector de Carga", preco: "Sob consulta" },
      { nome: "Câamera frontal", preco: "Sob consulta" },
      { nome: "Câamera Traseira", preco: "Sob consulta" },
      { nome: "Tampa Traseira", preco: "Sob consulta" },
      { nome: "Descreve a avaria", preco: "Sob consulta" }
    ]
  },
  "galaxy-a10s": {
    "Reparações disponíveis": [
      { nome: "Display/Touch", preco: "64,90€" },
      { nome: "Bateria", preco: "49,90€" },
      { nome: "Conector de Carga", preco: "44,90€" },
      { nome: "Câamera frontal", preco: "Sob consulta" },
      { nome: "Câamera Traseira", preco: "Sob consulta" },
      { nome: "Tampa Traseira", preco: "Sob consulta" },
      { nome: "Descreve a avaria", preco: "Sob consulta" }
    ]
  },
  "galaxy-a10": {
    "Reparações disponíveis": [
      { nome: "Display/Touch", preco: "69,90€" },
      { nome: "Bateria", preco: "49,90€" },
      { nome: "Conector de Carga", preco: "39,90€" },
      { nome: "Câamera frontal", preco: "Sob consulta" },
      { nome: "Câamera Traseira", preco: "Sob consulta" },
      { nome: "Tampa Traseira", preco: "Sob consulta" },
      { nome: "Descreve a avaria", preco: "Sob consulta" }
    ]
  },

  "galaxy-note-20-ultra-5g": {
    "Reparações disponíveis": [
      { nome: "Display/Touch", preco: "389,90€" },
      { nome: "Bateria", preco: "Sob consulta" },
      { nome: "Conector de Carga", preco: "Sob consulta" },
      { nome: "Câmara frontal", preco: "Sob consulta" },
      { nome: "Câmara Traseira", preco: "Sob consulta" },
      { nome: "Tampa Traseira", preco: "Sob consulta" },
      { nome: "Descreve a avaria", preco: "Sob consulta" }
    ]
  },
  "galaxy-note-20-5g": {
    "Reparações disponíveis": [
      { nome: "Display/Touch", preco: "389,90€" },
      { nome: "Bateria", preco: "Sob consulta" },
      { nome: "Conector de Carga", preco: "49,90€" },
      { nome: "Câmara frontal", preco: "Sob consulta" },
      { nome: "Câmara Traseira", preco: "Sob consulta" },
      { nome: "Tampa Traseira", preco: "Sob consulta" },
      { nome: "Descreve a avaria", preco: "Sob consulta" }
    ]
  },
  "galaxy-note-20-ultra": {
    "Reparações disponíveis": [
      { nome: "Display/Touch", preco: "389,90€" },
      { nome: "Bateria", preco: "49,90€" },
      { nome: "Conector de Carga", preco: "Sob consulta" },
      { nome: "Câmara frontal", preco: "Sob consulta" },
      { nome: "Câmara Traseira", preco: "139,90€" },
      { nome: "Tampa Traseira", preco: "99,90€" },
      { nome: "Descreve a avaria", preco: "Sob consulta" }
    ]
  },
  "galaxy-note-20": {
    "Reparações disponíveis": [
      { nome: "Display/Touch", preco: "219,90€" },
      { nome: "Bateria", preco: "49,90€" },
      { nome: "Conector de Carga", preco: "Sob consulta" },
      { nome: "Câmara frontal", preco: "Sob consulta" },
      { nome: "Câmara Traseira", preco: "Sob consulta" },
      { nome: "Tampa Traseira", preco: "Sob consulta" },
      { nome: "Descreve a avaria", preco: "Sob consulta" }
    ]
  },
  "galaxy-note10-plus-5g": {
    "Reparações disponíveis": []
  },
  "galaxy-note-10-plus": {
    "Reparações disponíveis": [
      { nome: "Display/Touch", preco: "329,90€" },
      { nome: "Bateria", preco: "49,90€" },
      { nome: "Conector de Carga", preco: "79,90€" },
      { nome: "Câmara frontal", preco: "Sob consulta" },
      { nome: "Câmara Traseira", preco: "89,90€" },
      { nome: "Tampa Traseira", preco: "89,90€" },
      { nome: "Descreve a avaria", preco: "Sob consulta" }
    ]
  },
  "galaxy-note-10": {
    "Reparações disponíveis": [
      { nome: "Display/Touch", preco: "279,90€" },
      { nome: "Bateria", preco: "49,90€" },
      { nome: "Conector de Carga", preco: "Sob consulta" },
      { nome: "Câmara frontal", preco: "Sob consulta" },
      { nome: "Câmara Traseira", preco: "Sob consulta" },
      { nome: "Tampa Traseira", preco: "79,90€" },
      { nome: "Descreve a avaria", preco: "Sob consulta" }
    ]
  },
  "galaxy-note-10-lite": {
    "Reparações disponíveis": [
      { nome: "Display/Touch", preco: "189,90€" },
      { nome: "Bateria", preco: "49,90€" },
      { nome: "Conector de Carga", preco: "49,90€" },
      { nome: "Câmara frontal", preco: "Sob consulta" },
      { nome: "Câmara Traseira", preco: "Sob consulta" },
      { nome: "Tampa Traseira", preco: "89,90€" },
      { nome: "Descreve a avaria", preco: "Sob consulta" }
    ]
  },
  "galaxy-note-9": {
    "Reparações disponíveis": [
      { nome: "Display/Touch", preco: "259,90€" },
      { nome: "Bateria", preco: "49,90€" },
      { nome: "Conector de Carga", preco: "89,90€" },
      { nome: "Câmara frontal", preco: "Sob consulta" },
      { nome: "Câmara Traseira", preco: "Sob consulta" },
      { nome: "Tampa Traseira", preco: "89,90€" },
      { nome: "Descreve a avaria", preco: "Sob consulta" }
    ]
  },
  "galaxy-j8": {
    "Reparações disponíveis": []
  },
  "galaxy-j6": {
    "Reparações disponíveis": [
      { nome: "Display/Touch", preco: "69,90€" },
      { nome: "Bateria", preco: "39,90€" },
      { nome: "Conector de Carga", preco: "Sob consulta" },
      { nome: "Câmara frontal", preco: "Sob consulta" },
      { nome: "Câmara Traseira", preco: "Sob consulta" },
      { nome: "Tampa Traseira", preco: "49,90€" },
      { nome: "Descreve a avaria", preco: "Sob consulta" }
    ]
  },
  "galaxy-m53": {
    "Reparações disponíveis": [
      { nome: "Display/Touch", preco: "129,90€" },
      { nome: "Bateria", preco: "Sob consulta" },
      { nome: "Conector de Carga", preco: "Sob consulta" },
      { nome: "Câmara frontal", preco: "Sob consulta" },
      { nome: "Câmara Traseira", preco: "Sob consulta" },
      { nome: "Tampa Traseira", preco: "Sob consulta" },
      { nome: "Descreve a avaria", preco: "Sob consulta" }
    ]
  },
  "galaxy-m13": {
    "Reparações disponíveis": [
      { nome: "Display/Touch", preco: "89,90€" },
      { nome: "Bateria", preco: "Sob consulta" },
      { nome: "Conector de Carga", preco: "Sob consulta" },
      { nome: "Câmara frontal", preco: "Sob consulta" },
      { nome: "Câmara Traseira", preco: "Sob consulta" },
      { nome: "Tampa Traseira", preco: "Sob consulta" },
      { nome: "Descreve a avaria", preco: "Sob consulta" }
    ]
  },
  "galaxy-m62": {
    "Reparações disponíveis": [
      { nome: "Display/Touch", preco: "159,90€" },
      { nome: "Bateria", preco: "Sob consulta" },
      { nome: "Conector de Carga", preco: "Sob consulta" },
      { nome: "Câmara frontal", preco: "Sob consulta" },
      { nome: "Câmara Traseira", preco: "Sob consulta" },
      { nome: "Tampa Traseira", preco: "Sob consulta" },
      { nome: "Descreve a avaria", preco: "Sob consulta" }
    ]
  },
  "galaxy-m52-5g": {
    "Reparações disponíveis": [
      { nome: "Display/Touch", preco: "119,90€" },
      { nome: "Bateria", preco: "Sob consulta" },
      { nome: "Conector de Carga", preco: "Sob consulta" },
      { nome: "Câmara frontal", preco: "Sob consulta" },
      { nome: "Câmara Traseira", preco: "Sob consulta" },
      { nome: "Tampa Traseira", preco: "Sob consulta" },
      { nome: "Descreve a avaria", preco: "Sob consulta" }
    ]
  },
  "galaxy-m32": {
    "Reparações disponíveis": []
  },
  "galaxy-m22": {
    "Reparações disponíveis": [
      { nome: "Display/Touch", preco: "89,90€" },
      { nome: "Bateria", preco: "Sob consulta" },
      { nome: "Conector de Carga", preco: "Sob consulta" },
      { nome: "Câmara frontal", preco: "Sob consulta" },
      { nome: "Câmara Traseira", preco: "Sob consulta" },
      { nome: "Tampa Traseira", preco: "Sob consulta" },
      { nome: "Descreve a avaria", preco: "Sob consulta" }
    ]
  },
  "galaxy-m12": {
    "Reparações disponíveis": [
      { nome: "Display/Touch", preco: "69,90€" },
      { nome: "Bateria", preco: "Sob consulta" },
      { nome: "Conector de Carga", preco: "Sob consulta" },
      { nome: "Câmara frontal", preco: "Sob consulta" },
      { nome: "Câmara Traseira", preco: "Sob consulta" },
      { nome: "Tampa Traseira", preco: "Sob consulta" },
      { nome: "Descreve a avaria", preco: "Sob consulta" }
    ]
  },
  "galaxy-m02s": {
    "Reparações disponíveis": []
  },
  "galaxy-m02": {
    "Reparações disponíveis": [
      { nome: "Display/Touch", preco: "49,90€" },
      { nome: "Bateria", preco: "Sob consulta" },
      { nome: "Conector de Carga", preco: "Sob consulta" },
      { nome: "Câmara frontal", preco: "Sob consulta" },
      { nome: "Câmara Traseira", preco: "Sob consulta" },
      { nome: "Tampa Traseira", preco: "Sob consulta" },
      { nome: "Descreve a avaria", preco: "Sob consulta" }
    ]
  },
  "galaxy-m51": {
    "Reparações disponíveis": [
      { nome: "Display/Touch", preco: "109,90€" },
      { nome: "Bateria", preco: "Sob consulta" },
      { nome: "Conector de Carga", preco: "Sob consulta" },
      { nome: "Câmara frontal", preco: "Sob consulta" },
      { nome: "Câmara Traseira", preco: "Sob consulta" },
      { nome: "Tampa Traseira", preco: "Sob consulta" },
      { nome: "Descreve a avaria", preco: "Sob consulta" }
    ]
  },
    "galaxy-m31s": {
    "Reparações disponíveis": [
      { nome: "Display/Touch", preco: "139,90€" },
      { nome: "Bateria", preco: "49,90€" },
      { nome: "Conector de Carga", preco: "39,90€" },
      { nome: "Câmera frontal", preco: "Sob consulta" },
      { nome: "Câamera Traseira", preco: "Sob consulta" },
      { nome: "Tampa Traseira", preco: "49,90€" },
      { nome: "Descreve a avaria", preco: "Sob consulta" }
    ]
  },
  "galaxy-m31": {
    "Reparações disponíveis": [
      { nome: "Display/Touch", preco: "89,90€" },
      { nome: "Bateria", preco: "Sob consulta" },
      { nome: "Conector de Carga", preco: "Sob consulta" },
      { nome: "Câmera frontal", preco: "Sob consulta" },
      { nome: "Câamera Traseira", preco: "49,90€" },
      { nome: "Tampa Traseira", preco: "Sob consulta" },
      { nome: "Descreve a avaria", preco: "Sob consulta" }
    ]
  },
  "galaxy-m21s": {
    "Reparações disponíveis": [
      { nome: "Display/Touch", preco: "89,90€" },
      { nome: "Bateria", preco: "Sob consulta" },
      { nome: "Conector de Carga", preco: "Sob consulta" },
      { nome: "Câamera frontal", preco: "Sob consulta" },
      { nome: "Câamera Traseira", preco: "Sob consulta" },
      { nome: "Tampa Traseira", preco: "Sob consulta" },
      { nome: "Descreve a avaria", preco: "Sob consulta" }
    ]
  },
  "galaxy-m21": {
    "Reparações disponíveis": [
      { nome: "Display/Touch", preco: "119,90€" },
      { nome: "Bateria", preco: "Sob consulta" },
      { nome: "Conector de Carga", preco: "Sob consulta" },
      { nome: "Câamera frontal", preco: "Sob consulta" },
      { nome: "Câamera Traseira", preco: "Sob consulta" },
      { nome: "Tampa Traseira", preco: "Sob consulta" },
      { nome: "Descreve a avaria", preco: "Sob consulta" }
    ]
  },
  "galaxy-m11": {
    "Reparações disponíveis": [
      { nome: "Display/Touch", preco: "64,90€" },
      { nome: "Bateria", preco: "Sob consulta" },
      { nome: "Conector de Carga", preco: "Sob consulta" },
      { nome: "Câamera frontal", preco: "Sob consulta" },
      { nome: "Câamera Traseira", preco: "Sob consulta" },
      { nome: "Tampa Traseira", preco: "Sob consulta" },
      { nome: "Descreve a avaria", preco: "Sob consulta" }
    ]
  },
  "galaxy-m01": {
    "Reparações disponíveis": [
      { nome: "Display/Touch", preco: "49,90€" },
      { nome: "Bateria", preco: "Sob consulta" },
      { nome: "Conector de Carga", preco: "Sob consulta" },
      { nome: "Câamera frontal", preco: "Sob consulta" },
      { nome: "Câamera Traseira", preco: "Sob consulta" },
      { nome: "Tampa Traseira", preco: "Sob consulta" },
      { nome: "Descreve a avaria", preco: "Sob consulta" }
    ]
  },
  "galaxy-m30s": {
    "Reparações disponíveis": [
      { nome: "Display/Touch", preco: "119,90€" },
      { nome: "Bateria", preco: "49,90€" },
      { nome: "Conector de Carga", preco: "Sob consulta" },
      { nome: "Câmera frontal", preco: "Sob consulta" },
      { nome: "Câamera Traseira", preco: "Sob consulta" },
      { nome: "Tampa Traseira", preco: "Sob consulta" },
      { nome: "Descreve a avaria", preco: "Sob consulta" }
    ]
  },
  "galaxy-m30": {
    "Reparações disponíveis": [
      { nome: "Display/Touch", preco: "Sob consulta" },
      { nome: "Bateria", preco: "Sob consulta" },
      { nome: "Conector de Carga", preco: "Sob consulta" },
      { nome: "Câamera frontal", preco: "Sob consulta" },
      { nome: "Câamera Traseira", preco: "Sob consulta" },
      { nome: "Tampa Traseira", preco: "Sob consulta" },
      { nome: "Descreve a avaria", preco: "Sob consulta" }
    ]
  },
  "galaxy-a73-5g": {
    "Reparações disponíveis": [
      { nome: "Display/Touch", preco: "139,90€" },
      { nome: "Bateria", preco: "Sob consulta" },
      { nome: "Conector de Carga", preco: "Sob consulta" },
      { nome: "Câamera frontal", preco: "Sob consulta" },
      { nome: "Câamera Traseira", preco: "Sob consulta" },
      { nome: "Tampa Traseira", preco: "Sob consulta" },
      { nome: "Descreve a avaria", preco: "Sob consulta" }
    ]
  },
  "galaxy-a53-5g": {
    "Reparações disponíveis": [
      { nome: "Display/Touch", preco: "139,90€" },
      { nome: "Bateria", preco: "49,90€" },
      { nome: "Conector de Carga", preco: "49,90€" },
      { nome: "Câamera frontal", preco: "49,90€" },
      { nome: "Câamera Traseira", preco: "Sob consulta" },
      { nome: "Tampa Traseira", preco: "Sob consulta" },
      { nome: "Descreve a avaria", preco: "Sob consulta" }
    ]
  },
  "galaxy-a23": {
    "Reparações disponíveis": [
      { nome: "Display/Touch", preco: "89,90€" },
      { nome: "Tampa Traseira", preco: "59,90€" },
      { nome: "Conector de Carga", preco: "Sob consulta" },
      { nome: "Câamera frontal", preco: "Sob consulta" },
      { nome: "Câamera Traseira", preco: "Sob consulta" },
      { nome: "Descreve a avaria", preco: "Sob consulta" }
    ]
  },
  "galaxy-a13-5g": {
    "Reparações disponíveis": [
      { nome: "Display/Touch", preco: "69,90€" },
      { nome: "Bateria", preco: "49,90€" },
      { nome: "Conector de Carga", preco: "44,90€" },
      { nome: "Câamera frontal", preco: "Sob consulta" },
      { nome: "Câamera Traseira", preco: "Sob consulta" },
      { nome: "Tampa Traseira", preco: "44,90€" },
      { nome: "Descreve a avaria", preco: "Sob consulta" }
    ]
  },
  "galaxy-a13": {
    "Reparações disponíveis": [
      { nome: "Display/Touch", preco: "69,90€" },
      { nome: "Bateria", preco: "Sob consulta" },
      { nome: "Conector de Carga", preco: "44,90€" },
      { nome: "Câamera frontal", preco: "44,90€" },
      { nome: "Câamera Traseira", preco: "Sob consulta" },
      { nome: "Tampa Traseira", preco: "44,90€" },
      { nome: "Descreve a avaria", preco: "Sob consulta" }
    ]
  },
  "galaxy-a03": {
    "Reparações disponíveis": [
      { nome: "Display/Touch", preco: "69,90€" },
      { nome: "Bateria", preco: "49,90€" },
      { nome: "Conector de Carga", preco: "44,90€" },
      { nome: "Câamera frontal", preco: "Sob consulta" },
      { nome: "Câamera Traseira", preco: "Sob consulta" },
      { nome: "Tampa Traseira", preco: "Sob consulta" },
      { nome: "Descreve a avaria", preco: "Sob consulta" }
    ]
  },
  "galaxy-a03s": {
    "Reparações disponíveis": [
      { nome: "Display/Touch", preco: "64,90€" },
      { nome: "Bateria", preco: "49,90€" },
      { nome: "Conector de Carga", preco: "44,90€" },
      { nome: "Câamera frontal", preco: "39,90€" },
      { nome: "Câamera Traseira", preco: "39,90€" },
      { nome: "Descreve a avaria", preco: "Sob consulta" }
    ]
  },
  "galaxy-a22-5g": {
    "Reparações disponíveis": [
      { nome: "Display/Touch", preco: "89,90€" },
      { nome: "Bateria", preco: "49,90€" },
      { nome: "Conector de Carga", preco: "44,90€" },
      { nome: "Câamera frontal", preco: "Sob consulta" },
      { nome: "Câamera Traseira", preco: "Sob consulta" },
      { nome: "Tampa Traseira", preco: "59,90€" },
      { nome: "Descreve a avaria", preco: "Sob consulta" }
    ]
  },
  "galaxy-a52-5g": {
    "Reparações disponíveis": [
      { nome: "Display/Touch", preco: "129,90€" },
      { nome: "Bateria", preco: "Sob consulta" },
      { nome: "Conector de Carga", preco: "54,90€" },
      { nome: "Câamera frontal", preco: "49,90€" },
      { nome: "Câamera Traseira", preco: "Sob consulta" },
      { nome: "Tampa Traseira", preco: "Sob consulta" },
      { nome: "Descreve a avaria", preco: "Sob consulta" }
    ]
  },
  "galaxy-a32-5g": {
    "Reparações disponíveis": [
      { nome: "Display/Touch", preco: "89,90€" },
      { nome: "Bateria", preco: "49,90€" },
      { nome: "Conector de Carga", preco: "49,90€" },
      { nome: "Câamera frontal", preco: "Sob consulta" },
      { nome: "Câamera Traseira", preco: "Sob consulta" },
      { nome: "Tampa Traseira", preco: "Sob consulta" },
      { nome: "Descreve a avaria", preco: "Sob consulta" }
    ]
  },
  "galaxy-a02": {
    "Reparações disponíveis": [
      { nome: "Display/Touch", preco: "69,90€" },
      { nome: "Bateria", preco: "Sob consulta" },
      { nome: "Conector de Carga", preco: "Sob consulta" },
      { nome: "Câamera frontal", preco: "Sob consulta" },
      { nome: "Câamera Traseira", preco: "Sob consulta" },
      { nome: "Tampa Traseira", preco: "Sob consulta" },
      { nome: "Descreve a avaria", preco: "Sob consulta" }
    ]
  },
  "galaxy-a72": {
    "Reparações disponíveis": [
      { nome: "Display/Touch", preco: "119,90€" },
      { nome: "Bateria", preco: "Sob consulta" },
      { nome: "Conector de Carga", preco: "Sob consulta" },
      { nome: "Câamera frontal", preco: "Sob consulta" },
      { nome: "Câamera Traseira", preco: "Sob consulta" },
      { nome: "Tampa Traseira", preco: "Sob consulta" },
      { nome: "Descreve a avaria", preco: "Sob consulta" }
    ]
  },
  "galaxy-a54": {
    "Reparações disponíveis": [
      { nome: "Display/Touch", preco: "Sob consulta" },
      { nome: "Bateria", preco: "Sob consulta" },
      { nome: "Conector de Carga", preco: "Sob consulta" },
      { nome: "Câmera frontal", preco: "Sob consulta" },
      { nome: "Câamera Traseira", preco: "Sob consulta" },
      { nome: "Tampa Traseira", preco: "Sob consulta" },
      { nome: "Descreve a avaria", preco: "Sob consulta" }
    ]
  },
  "galaxy-a24-4g": {
    "Reparações disponíveis": [
      { nome: "Display/Touch", preco: "Sob consulta" },
      { nome: "Bateria", preco: "Sob consulta" },
      { nome: "Conector de Carga", preco: "Sob consulta" },
      { nome: "Câmera frontal", preco: "Sob consulta" },
      { nome: "Câamera Traseira", preco: "Sob consulta" },
      { nome: "Tampa Traseira", preco: "Sob consulta" },
      { nome: "Descreve a avaria", preco: "Sob consulta" }
    ]
  },
  "galaxy-a34-5g": {
    "Reparações disponíveis": [
      { nome: "Display/Touch", preco: "129,90€" },
      { nome: "Bateria", preco: "Sob consulta" },
      { nome: "Conector de Carga", preco: "49,90€" },
      { nome: "Câmera frontal", preco: "54,90€" },
      { nome: "Câamera Traseira", preco: "Sob consulta" },
      { nome: "Tampa Traseira", preco: "Sob consulta" },
      { nome: "Descreve a avaria", preco: "Sob consulta" }
    ]
  },
  "galaxy-a34": {
    "Reparações disponíveis": [
      { nome: "Display/Touch", preco: "Sob consulta" },
      { nome: "Bateria", preco: "Sob consulta" },
      { nome: "Conector de Carga", preco: "Sob consulta" },
      { nome: "Câamera frontal", preco: "Sob consulta" },
      { nome: "Câamera Traseira", preco: "Sob consulta" },
      { nome: "Tampa Traseira", preco: "Sob consulta" },
      { nome: "Descreve a avaria", preco: "Sob consulta" }
    ]
  },
  "galaxy-a14-5g": {
    "Reparações disponíveis": [
      { nome: "Display/Touch", preco: "89,90€" },
      { nome: "Bateria", preco: "Sob consulta" },
      { nome: "Conector de Carga", preco: "Sob consulta" },
      { nome: "Câamera frontal", preco: "Sob consulta" },
      { nome: "Câamera Traseira", preco: "Sob consulta" },
      { nome: "Tampa Traseira", preco: "Sob consulta" },
      { nome: "Descreve a avaria", preco: "Sob consulta" }
    ]
  },
  "galaxy-a14": {
    "Reparações disponíveis": [
      { nome: "Display/Touch", preco: "89,90€" },
      { nome: "Bateria", preco: "Sob consulta" },
      { nome: "Conector de Carga", preco: "44,90€" },
      { nome: "Câamera frontal", preco: "Sob consulta" },
      { nome: "Câamera Traseira", preco: "Sob consulta" },
      { nome: "Tampa Traseira", preco: "Sob consulta" },
      { nome: "Descreve a avaria", preco: "Sob consulta" }
    ]
  },
  "galaxy-a04e": {
    "Reparações disponíveis": [
      { nome: "Display/Touch", preco: "Sob consulta" },
      { nome: "Bateria", preco: "Sob consulta" },
      { nome: "Conector de Carga", preco: "Sob consulta" },
      { nome: "Câamera frontal", preco: "Sob consulta" },
      { nome: "Câamera Traseira", preco: "Sob consulta" },
      { nome: "Tampa Traseira", preco: "Sob consulta" },
      { nome: "Descreve a avaria", preco: "Sob consulta" }
    ]
  },
  "galaxy-a04s": {
    "Reparações disponíveis": [
      { nome: "Display/Touch", preco: "64,90€" },
      { nome: "Bateria", preco: "49,90€" },
      { nome: "Conector de Carga", preco: "49,90€" },
      { nome: "Câamera frontal", preco: "Sob consulta" },
      { nome: "Câamera Traseira", preco: "Sob consulta" },
      { nome: "Tampa Traseira", preco: "Sob consulta" },
      { nome: "Descreve a avaria", preco: "Sob consulta" }
    ]
  },
  "galaxy-a23-5g": {
    "Reparações disponíveis": [
      { nome: "Display/Touch", preco: "89,90€" },
      { nome: "Bateria", preco: "Sob consulta" },
      { nome: "Conector de Carga", preco: "49,90€" },
      { nome: "Câamera frontal", preco: "Sob consulta" },
      { nome: "Câamera Traseira", preco: "Sob consulta" },
      { nome: "Tampa Traseira", preco: "Sob consulta" },
      { nome: "Descreve a avaria", preco: "Sob consulta" }
    ]
  },
  "galaxy-a73-5g": {
    "Reparações disponíveis": [
      { nome: "Display/Touch", preco: "139,90€" },
      { nome: "Bateria", preco: "Sob consulta" },
      { nome: "Conector de Carga", preco: "Sob consulta" },
      { nome: "Câmera frontal", preco: "Sob consulta" },
      { nome: "Câamera Traseira", preco: "Sob consulta" },
      { nome: "Tampa Traseira", preco: "Sob consulta" },
      { nome: "Descreve a avaria", preco: "Sob consulta" }
    ]
  },
  "galaxy-a53-5g": {
    "Reparações disponíveis": [
      { nome: "Display/Touch", preco: "139,90€" },
      { nome: "Bateria", preco: "49,90€" },
      { nome: "Conector de Carga", preco: "49,90€" },
      { nome: "Câamera frontal", preco: "49,90€" },
      { nome: "Câamera Traseira", preco: "Sob consulta" },
      { nome: "Tampa Traseira", preco: "Sob consulta" },
      { nome: "Descreve a avaria", preco: "Sob consulta" }
    ]
  },
  "galaxy-a33-5g": {
    "Reparações disponíveis": [
      { nome: "Display/Touch", preco: "109,90€" },
      { nome: "Bateria", preco: "49,90€" },
      { nome: "Conector de Carga", preco: "49,90€" },
      { nome: "Câamera frontal", preco: "Sob consulta" },
      { nome: "Câamera Traseira", preco: "Sob consulta" },
      { nome: "Tampa Traseira", preco: "Sob consulta" },
      { nome: "Descreve a avaria", preco: "Sob consulta" }
    ]
  },
  "galaxy-a23": {
    "Reparações disponíveis": [
      { nome: "Display/Touch", preco: "89,90€" },
      { nome: "Tampa Traseira", preco: "59,90€" },
      { nome: "Conector de Carga", preco: "Sob consulta" },
      { nome: "Câamera frontal", preco: "Sob consulta" },
      { nome: "Câamera Traseira", preco: "Sob consulta" },
      { nome: "Tampa Traseira", preco: "Sob consulta" },
      { nome: "Descreve a avaria", preco: "Sob consulta" }
    ]
  },
  "galaxy-a13-5g": {
    "Reparações disponíveis": [
      { nome: "Display/Touch", preco: "69,90€" },
      { nome: "Bateria", preco: "49,90€" },
      { nome: "Conector de Carga", preco: "44,90€" },
      { nome: "Câamera frontal", preco: "Sob consulta" },
      { nome: "Câamera Traseira", preco: "Sob consulta" },
      { nome: "Tampa Traseira", preco: "44,90€" },
      { nome: "Descreve a avaria", preco: "Sob consulta" }
    ]
  },
  "galaxy-a13": {
    "Reparações disponíveis": [
      { nome: "Display/Touch", preco: "69,90€" },
      { nome: "Bateria", preco: "Sob consulta" },
      { nome: "Conector de Carga", preco: "44,90€" },
      { nome: "Câamera frontal", preco: "44,90€" },
      { nome: "Câamera Traseira", preco: "Sob consulta" },
      { nome: "Tampa Traseira", preco: "44,90€" },
      { nome: "Descreve a avaria", preco: "Sob consulta" }
    ]
  },
  "galaxy-a03": {
    "Reparações disponíveis": [
      { nome: "Display/Touch", preco: "69,90€" },
      { nome: "Bateria", preco: "49,90€" },
      { nome: "Conector de Carga", preco: "44,90€" },
      { nome: "Câamera frontal", preco: "Sob consulta" },
      { nome: "Câamera Traseira", preco: "Sob consulta" },
      { nome: "Tampa Traseira", preco: "Sob consulta" },
      { nome: "Descreve a avaria", preco: "Sob consulta" }
    ]
  },
  "galaxy-a03s": {
    "Reparações disponíveis": [
      { nome: "Display/Touch", preco: "64,90€" },
      { nome: "Bateria", preco: "49,90€" },
      { nome: "Conector de Carga", preco: "44,90€" },
      { nome: "Câamera frontal", preco: "39,90€" },
      { nome: "Câamera Traseira", preco: "39,90€" },
      { nome: "Descreve a avaria", preco: "Sob consulta" }
    ]
  },
  "galaxy-a22-5g": {
    "Reparações disponíveis": [
      { nome: "Display/Touch", preco: "89,90€" },
      { nome: "Bateria", preco: "49,90€" },
      { nome: "Conector de Carga", preco: "44,90€" },
      { nome: "Câamera frontal", preco: "Sob consulta" },
      { nome: "Câamera Traseira", preco: "Sob consulta" },
      { nome: "Tampa Traseira", preco: "59,90€" },
      { nome: "Descreve a avaria", preco: "Sob consulta" }
    ]
  },
  "galaxy-a52-5g": {
    "Reparações disponíveis": [
      { nome: "Display/Touch", preco: "129,90€" },
      { nome: "Bateria", preco: "Sob consulta" },
      { nome: "Conector de Carga", preco: "54,90€" },
      { nome: "Câamera frontal", preco: "49,90€" },
      { nome: "Câamera Traseira", preco: "Sob consulta" },
      { nome: "Tampa Traseira", preco: "Sob consulta" },
      { nome: "Descreve a avaria", preco: "Sob consulta" }
    ]
  },
    "galaxy-a32-5g": {
    "Reparações disponíveis": [
      { nome: "Display/Touch", preco: "89,90€" },
      { nome: "Bateria", preco: "49,90€" },
      { nome: "Conector de Carga", preco: "49,90€" },
      { nome: "Câamera frontal", preco: "Sob consulta" },
      { nome: "Câamera Traseira", preco: "Sob consulta" },
      { nome: "Tampa Traseira", preco: "Sob consulta" },
      { nome: "Descreve a avaria", preco: "Sob consulta" }
    ]
  },
  "galaxy-a02": {
    "Reparações disponíveis": [
      { nome: "Display/Touch", preco: "69,90€" },
      { nome: "Bateria", preco: "Sob consulta" },
      { nome: "Conector de Carga", preco: "Sob consulta" },
      { nome: "Câamera frontal", preco: "Sob consulta" },
      { nome: "Câamera Traseira", preco: "Sob consulta" },
      { nome: "Tampa Traseira", preco: "Sob consulta" },
      { nome: "Descreve a avaria", preco: "Sob consulta" }
    ]
  },
  "galaxy-a72": {
    "Reparações disponíveis": [
      { nome: "Display/Touch", preco: "119,90€" },
      { nome: "Bateria", preco: "Sob consulta" },
      { nome: "Conector de Carga", preco: "Sob consulta" },
      { nome: "Câamera frontal", preco: "Sob consulta" },
      { nome: "Câamera Traseira", preco: "Sob consulta" },
      { nome: "Tampa Traseira", preco: "Sob consulta" },
      { nome: "Descreve a avaria", preco: "Sob consulta" }
    ]
  },
  "galaxy-a52s": {
    "Reparações disponíveis": [
      { nome: "Display/Touch", preco: "129,90€" },
      { nome: "Bateria", preco: "Sob consulta" },
      { nome: "Conector de Carga", preco: "Sob consulta" },
      { nome: "Câamera frontal", preco: "Sob consulta" },
      { nome: "Câamera Traseira", preco: "Sob consulta" },
      { nome: "Tampa Traseira", preco: "Sob consulta" },
      { nome: "Descreve a avaria", preco: "Sob consulta" }
    ]
  },
  "galaxy-a52": {
    "Reparações disponíveis": [
      { nome: "Display/Touch", preco: "129,90€" },
      { nome: "Bateria", preco: "49,90€" },
      { nome: "Conector de Carga", preco: "Sob consulta" },
      { nome: "Câamera frontal", preco: "Sob consulta" },
      { nome: "Câamera Traseira", preco: "Sob consulta" },
      { nome: "Tampa Traseira", preco: "Sob consulta" },
      { nome: "Descreve a avaria", preco: "Sob consulta" }
    ]
  },
  "galaxy-a32": {
    "Reparações disponíveis": [
      { nome: "Display/Touch", preco: "89,90€" },
      { nome: "Bateria", preco: "49,90€" },
      { nome: "Conector de Carga", preco: "Sob consulta" },
      { nome: "Câamera frontal", preco: "Sob consulta" },
      { nome: "Câamera Traseira", preco: "Sob consulta" },
      { nome: "Tampa Traseira", preco: "Sob consulta" },
      { nome: "Descreve a avaria", preco: "Sob consulta" }
    ]
  },
  "galaxy-a22": {
    "Reparações disponíveis": [
      { nome: "Display/Touch", preco: "89,90€" },
      { nome: "Bateria", preco: "49,90€" },
      { nome: "Conector de Carga", preco: "Sob consulta" },
      { nome: "Câamera frontal", preco: "Sob consulta" },
      { nome: "Câamera Traseira", preco: "Sob consulta" },
      { nome: "Tampa Traseira", preco: "Sob consulta" },
      { nome: "Descreve a avaria", preco: "Sob consulta" }
    ]
  },
  "galaxy-a42-5g": {
    "Reparações disponíveis": [
      { nome: "Display/Touch", preco: "89,90€" },
      { nome: "Bateria", preco: "49,90€" },
      { nome: "Conector de Carga", preco: "49,90€" },
      { nome: "Câamera frontal", preco: "64,90€" },
      { nome: "Câamera Traseira", preco: "Sob consulta" },
      { nome: "Tampa Traseira", preco: "Sob consulta" },
      { nome: "Descreve a avaria", preco: "Sob consulta" }
    ]
  },
  "galaxy-a71-5g": {
    "Reparações disponíveis": [
      { nome: "Display/Touch", preco: "149,90€" },
      { nome: "Bateria", preco: "Sob consulta" },
      { nome: "Conector de Carga", preco: "Sob consulta" },
      { nome: "Câamera frontal", preco: "Sob consulta" },
      { nome: "Câamera Traseira", preco: "Sob consulta" },
      { nome: "Tampa Traseira", preco: "Sob consulta" },
      { nome: "Descreve a avaria", preco: "Sob consulta" }
    ]
  },
  "galaxy-a51-5g": {
    "Reparações disponíveis": [
      { nome: "Display/Touch", preco: "129,90€" },
      { nome: "Bateria", preco: "Sob consulta" },
      { nome: "Conector de Carga", preco: "Sob consulta" },
      { nome: "Câamera frontal", preco: "Sob consulta" },
      { nome: "Câamera Traseira", preco: "59,90€" },
      { nome: "Tampa Traseira", preco: "49,90€" },
      { nome: "Descreve a avaria", preco: "Sob consulta" }
    ]
  },
  "galaxy-a21": {
    "Reparações disponíveis": [
      { nome: "Display/Touch", preco: "Sob consulta" },
      { nome: "Bateria", preco: "Sob consulta" },
      { nome: "Conector de Carga", preco: "Sob consulta" },
      { nome: "Câamera frontal", preco: "Sob consulta" },
      { nome: "Câamera Traseira", preco: "Sob consulta" },
      { nome: "Tampa Traseira", preco: "Sob consulta" },
      { nome: "Descreve a avaria", preco: "Sob consulta" }
    ]
  },
  "galaxy-a11": {
    "Reparações disponíveis": [
      { nome: "Display/Touch", preco: "69,90€" },
      { nome: "Bateria", preco: "49,90€" },
      { nome: "Conector de Carga", preco: "39,90€" },
      { nome: "Câamera frontal", preco: "Sob consulta" },
      { nome: "Câamera Traseira", preco: "Sob consulta" },
      { nome: "Tampa Traseira", preco: "Sob consulta" },
      { nome: "Descreve a avaria", preco: "Sob consulta" }
    ]
  },
  "galaxy-a71": {
    "Reparações disponíveis": [
      { nome: "Display/Touch", preco: "109,90€" },
      { nome: "Bateria", preco: "49,90€" },
      { nome: "Conector de Carga", preco: "Sob consulta" },
      { nome: "Câamera frontal", preco: "Sob consulta" },
      { nome: "Câamera Traseira", preco: "Sob consulta" },
      { nome: "Tampa Traseira", preco: "Sob consulta" },
      { nome: "Descreve a avaria", preco: "Sob consulta" }
    ]
  },
  "galaxy-a51": {
    "Reparações disponíveis": [
      { nome: "Display/Touch", preco: "109,90€" },
      { nome: "Bateria", preco: "49,90€" },
      { nome: "Conector de Carga", preco: "Sob consulta" },
      { nome: "Câamera frontal", preco: "Sob consulta" },
      { nome: "Câamera Traseira", preco: "Sob consulta" },
      { nome: "Tampa Traseira", preco: "Sob consulta" },
      { nome: "Descreve a avaria", preco: "Sob consulta" }
    ]
  },
  "galaxy-a42": {
    "Reparações disponíveis": [
      { nome: "Display/Touch", preco: "89,90€" },
      { nome: "Bateria", preco: "Sob consulta" },
      { nome: "Conector de Carga", preco: "Sob consulta" },
      { nome: "Câamera frontal", preco: "Sob consulta" },
      { nome: "Câamera Traseira", preco: "Sob consulta" },
      { nome: "Tampa Traseira", preco: "Sob consulta" },
      { nome: "Descreve a avaria", preco: "Sob consulta" }
    ]
  },
  "galaxy-a41": {
    "Reparações disponíveis": [
      { nome: "Display/Touch", preco: "99,90€" },
      { nome: "Bateria", preco: "49,90€" },
      { nome: "Conector de Carga", preco: "Sob consulta" },
      { nome: "Câamera frontal", preco: "Sob consulta" },
      { nome: "Câamera Traseira", preco: "Sob consulta" },
      { nome: "Tampa Traseira", preco: "Sob consulta" },
      { nome: "Descreve a avaria", preco: "Sob consulta" }
    ]
  },
  "galaxy-a31": {
    "Reparações disponíveis": [
      { nome: "Display/Touch", preco: "89,90€" },
      { nome: "Bateria", preco: "49,90€" },
      { nome: "Conector de Carga", preco: "Sob consulta" },
      { nome: "Câamera frontal", preco: "Sob consulta" },
      { nome: "Câamera Traseira", preco: "Sob consulta" },
      { nome: "Tampa Traseira", preco: "Sob consulta" },
      { nome: "Descreve a avaria", preco: "Sob consulta" }
    ]
  },
  "galaxy-a21s": {
    "Reparações disponíveis": [
      { nome: "Display/Touch", preco: "79,90€" },
      { nome: "Bateria", preco: "49,90€" },
      { nome: "Conector de Carga", preco: "44,90€" },
      { nome: "Câamera frontal", preco: "79,90€" },
      { nome: "Câamera Traseira", preco: "79,90€" },
      { nome: "Tampa Traseira", preco: "69,90€" },
      { nome: "Descreve a avaria", preco: "Sob consulta" }
    ]
  },
  "galaxy-a12": {
    "Reparações disponíveis": [
      { nome: "Display/Touch", preco: "69,90€" },
      { nome: "Bateria", preco: "Sob consulta" },
      { nome: "Conector de Carga", preco: "Sob consulta" },
      { nome: "Câamera frontal", preco: "Sob consulta" },
      { nome: "Câamera Traseira", preco: "Sob consulta" },
      { nome: "Tampa Traseira", preco: "Sob consulta" },
      { nome: "Descreve a avaria", preco: "Sob consulta" }
    ]
  },
  "galaxy-a02s": {
    "Reparações disponíveis": [
      { nome: "Display/Touch", preco: "59,90€" },
      { nome: "Bateria", preco: "Sob consulta" },
      { nome: "Conector de Carga", preco: "Sob consulta" },
      { nome: "Câamera frontal", preco: "Sob consulta" },
      { nome: "Câamera Traseira", preco: "Sob consulta" },
      { nome: "Tampa Traseira", preco: "Sob consulta" },
      { nome: "Descreve a avaria", preco: "Sob consulta" }
    ]
  },
  "galaxy-a01": {
    "Reparações disponíveis": [
      { nome: "Display/Touch", preco: "49,90€" },
      { nome: "Conector de Carga", preco: "39,90€" },
      { nome: "Bateria", preco: "Sob consulta" },
      { nome: "Câamera frontal", preco: "Sob consulta" },
      { nome: "Câamera Traseira", preco: "Sob consulta" },
      { nome: "Tampa Traseira", preco: "Sob consulta" },
      { nome: "Descreve a avaria", preco: "Sob consulta" }
    ]
  },
  "galaxy-a70s": {
    "Reparações disponíveis": [
      { nome: "Display/Touch", preco: "Sob consulta" },
      { nome: "Bateria", preco: "Sob consulta" },
      { nome: "Conector de Carga", preco: "Sob consulta" },
      { nome: "Câmara frontal", preco: "Sob consulta" },
      { nome: "Câmara Traseira", preco: "Sob consulta" },
      { nome: "Tampa Traseira", preco: "Sob consulta" },
      { nome: "Descreve a avaria", preco: "Sob consulta" }
    ]
  },
  "galaxy-a90-5g": {
    "Reparações disponíveis": [
      { nome: "Display/Touch", preco: "Sob consulta" },
      { nome: "Bateria", preco: "Sob consulta" },
      { nome: "Conector de Carga", preco: "Sob consulta" },
      { nome: "Câmara frontal", preco: "Sob consulta" },
      { nome: "Câmara Traseira", preco: "Sob consulta" },
      { nome: "Tampa Traseira", preco: "Sob consulta" },
      { nome: "Descreve a avaria", preco: "Sob consulta" }
    ]
  },
  "galaxy-a50s": {
    "Reparações disponíveis": [
      { nome: "Display/Touch", preco: "109,90€" },
      { nome: "Bateria", preco: "Sob consulta" },
      { nome: "Conector de Carga", preco: "49,90€" },
      { nome: "Câmara frontal", preco: "Sob consulta" },
      { nome: "Câmara Traseira", preco: "Sob consulta" },
      { nome: "Tampa Traseira", preco: "Sob consulta" },
      { nome: "Descreve a avaria", preco: "Sob consulta" }
    ]
  },
  "galaxy-a10e": {
    "Reparações disponíveis": [
      { nome: "Display/Touch", preco: "Sob consulta" },
      { nome: "Bateria", preco: "Sob consulta" },
      { nome: "Conector de Carga", preco: "49,90€" },
      { nome: "Câmara frontal", preco: "Sob consulta" },
      { nome: "Câmara Traseira", preco: "Sob consulta" },
      { nome: "Tampa Traseira", preco: "Sob consulta" },
      { nome: "Descreve a avaria", preco: "Sob consulta" }
    ]
  },
  "galaxy-a80": {
    "Reparações disponíveis": [
      { nome: "Display/Touch", preco: "119,90€" },
      { nome: "Bateria", preco: "49,90€" },
      { nome: "Conector de Carga", preco: "Sob consulta" },
      { nome: "Câmara frontal", preco: "Sob consulta" },
      { nome: "Câmara Traseira", preco: "Sob consulta" },
      { nome: "Tampa Traseira", preco: "Sob consulta" },
      { nome: "Descreve a avaria", preco: "Sob consulta" }
    ]
  },
  "galaxy-a70": {
    "Reparações disponíveis": [
      { nome: "Display/Touch", preco: "109,90€" },
      { nome: "Bateria", preco: "49,90€" },
      { nome: "Conector de Carga", preco: "59,90€" },
      { nome: "Câmara frontal", preco: "Sob consulta" },
      { nome: "Câmara Traseira", preco: "59,90€" },
      { nome: "Tampa Traseira", preco: "49,90€" },
      { nome: "Descreve a avaria", preco: "Sob consulta" }
    ]
  },
  "galaxy-a50": {
    "Reparações disponíveis": [
      { nome: "Display/Touch", preco: "89,90€" },
      { nome: "Bateria", preco: "49,90€" },
      { nome: "Conector de Carga", preco: "49,90€" },
      { nome: "Câmara frontal", preco: "59,90€" },
      { nome: "Câmara Traseira", preco: "Sob consulta" },
      { nome: "Tampa Traseira", preco: "Sob consulta" },
      { nome: "Descreve a avaria", preco: "Sob consulta" }
    ]
  },
  "galaxy-a40": {
    "Reparações disponíveis": [
      { nome: "Display/Touch", preco: "89,90€" },
      { nome: "Bateria", preco: "49,90€" },
      { nome: "Conector de Carga", preco: "49,90€" },
      { nome: "Câmara frontal", preco: "59,90€" },
      { nome: "Câmara Traseira", preco: "Sob consulta" },
      { nome: "Tampa Traseira", preco: "Sob consulta" },
      { nome: "Descreve a avaria", preco: "Sob consulta" }
    ]
  },
  "galaxy-a30s": {
    "Reparações disponíveis": [
      { nome: "Display/Touch", preco: "89,90€" },
      { nome: "Bateria", preco: "49,90€" },
      { nome: "Conector de Carga", preco: "Sob consulta" },
      { nome: "Câmara frontal", preco: "Sob consulta" },
      { nome: "Câmara Traseira", preco: "Sob consulta" },
      { nome: "Tampa Traseira", preco: "Sob consulta" },
      { nome: "Descreve a avaria", preco: "Sob consulta" }
    ]
  },
  "galaxy-a30": {
    "Reparações disponíveis": [
      { nome: "Display/Touch", preco: "89,90€" },
      { nome: "Bateria", preco: "49,90€" },
      { nome: "Conector de Carga", preco: "Sob consulta" },
      { nome: "Câmara frontal", preco: "Sob consulta" },
      { nome: "Câmara Traseira", preco: "Sob consulta" },
      { nome: "Tampa Traseira", preco: "Sob consulta" },
      { nome: "Descreve a avaria", preco: "Sob consulta" }
    ]
  },
  "galaxy-a20e": {
    "Reparações disponíveis": [
      { nome: "Display/Touch", preco: "69,90€" },
      { nome: "Bateria", preco: "49,90€" },
      { nome: "Conector de Carga", preco: "49,90€" },
      { nome: "Câmara frontal", preco: "Sob consulta" },
      { nome: "Câmara Traseira", preco: "Sob consulta" },
      { nome: "Tampa Traseira", preco: "Sob consulta" },
      { nome: "Descreve a avaria", preco: "Sob consulta" }
    ]
  },
  "galaxy-a20s": {
    "Reparações disponíveis": [
      { nome: "Display/Touch", preco: "69,90€" },
      { nome: "Bateria", preco: "49,90€" },
      { nome: "Conector de Carga", preco: "Sob consulta" },
      { nome: "Câmara frontal", preco: "Sob consulta" },
      { nome: "Câmara Traseira", preco: "Sob consulta" },
      { nome: "Tampa Traseira", preco: "Sob consulta" },
      { nome: "Descreve a avaria", preco: "Sob consulta" }
    ]
  },
  "galaxy-a20": {
    "Reparações disponíveis": [
      { nome: "Display/Touch", preco: "69,90€" },
      { nome: "Bateria", preco: "49,90€" },
      { nome: "Conector de Carga", preco: "Sob consulta" },
      { nome: "Câmara frontal", preco: "Sob consulta" },
      { nome: "Câmara Traseira", preco: "Sob consulta" },
      { nome: "Tampa Traseira", preco: "Sob consulta" },
      { nome: "Descreve a avaria", preco: "Sob consulta" }
    ]
  },
  "galaxy-a10s": {
    "Reparações disponíveis": [
      { nome: "Display/Touch", preco: "64,90€" },
      { nome: "Bateria", preco: "49,90€" },
      { nome: "Conector de Carga", preco: "44,90€" },
      { nome: "Câmara frontal", preco: "Sob consulta" },
      { nome: "Câmara Traseira", preco: "Sob consulta" },
      { nome: "Tampa Traseira", preco: "Sob consulta" },
      { nome: "Descreve a avaria", preco: "Sob consulta" }
    ]
  },
  "galaxy-a10": {
    "Reparações disponíveis": [
      { nome: "Display/Touch", preco: "69,90€" },
      { nome: "Bateria", preco: "49,90€" },
      { nome: "Conector de Carga", preco: "39,90€" },
      { nome: "Câmara frontal", preco: "Sob consulta" },
      { nome: "Câmara Traseira", preco: "Sob consulta" },
      { nome: "Tampa Traseira", preco: "Sob consulta" },
      { nome: "Descreve a avaria", preco: "Sob consulta" }
    ]
  },
  "galaxy-note-20-ultra-5g": {
    "Reparações disponíveis": [
      { nome: "Display/Touch", preco: "389,90€" },
      { nome: "Bateria", preco: "Sob consulta" },
      { nome: "Conector de Carga", preco: "Sob consulta" },
      { nome: "Câmera frontal", preco: "Sob consulta" },
      { nome: "Câmera Traseira", preco: "Sob consulta" },
      { nome: "Tampa Traseira", preco: "Sob consulta" },
      { nome: "Descreve a avaria", preco: "Sob consulta" }
    ]
  },
  "galaxy-note-20-5g": {
    "Reparações disponíveis": [
      { nome: "Display/Touch", preco: "389,90€" },
      { nome: "Bateria", preco: "Sob consulta" },
      { nome: "Conector de Carga", preco: "49,90€" },
      { nome: "Câmera frontal", preco: "Sob consulta" },
      { nome: "Câamera Traseira", preco: "Sob consulta" },
      { nome: "Tampa Traseira", preco: "Sob consulta" },
      { nome: "Descreve a avaria", preco: "Sob consulta" }
    ]
  },
  "galaxy-note-20-ultra": {
    "Reparações disponíveis": [
      { nome: "Display/Touch", preco: "389,90€" },
      { nome: "Bateria", preco: "49,90€" },
      { nome: "Conector de Carga", preco: "Sob consulta" },
      { nome: "Câamera frontal", preco: "Sob consulta" },
      { nome: "Câamera Traseira", preco: "139,90€" },
      { nome: "Tampa Traseira", preco: "99,90€" },
      { nome: "Descreve a avaria", preco: "Sob consulta" }
    ]
  },
  "galaxy-note-20": {
    "Reparações disponíveis": [
      { nome: "Display/Touch", preco: "219,90€" },
      { nome: "Bateria", preco: "49,90€" },
      { nome: "Conector de Carga", preco: "Sob consulta" },
      { nome: "Câamera frontal", preco: "Sob consulta" },
      { nome: "Câamera Traseira", preco: "Sob consulta" },
      { nome: "Tampa Traseira", preco: "Sob consulta" },
      { nome: "Descreve a avaria", preco: "Sob consulta" }
    ]
  },
  "galaxy-note10-plus-5g": {
    "Reparações disponíveis": []
  },
  "galaxy-note-10-plus": {
    "Reparações disponíveis": [
      { nome: "Display/Touch", preco: "329,90€" },
      { nome: "Bateria", preco: "49,90€" },
      { nome: "Conector de Carga", preco: "79,90€" },
      { nome: "Câamera frontal", preco: "Sob consulta" },
      { nome: "Câamera Traseira", preco: "89,90€" },
      { nome: "Tampa Traseira", preco: "89,90€" },
      { nome: "Descreve a avaria", preco: "Sob consulta" }
    ]
  },
  "galaxy-note-10": {
    "Reparações disponíveis": [
      { nome: "Display/Touch", preco: "279,90€" },
      { nome: "Bateria", preco: "49,90€" },
      { nome: "Conector de Carga", preco: "Sob consulta" },
      { nome: "Câamera frontal", preco: "Sob consulta" },
      { nome: "Câamera Traseira", preco: "Sob consulta" },
      { nome: "Tampa Traseira", preco: "79,90€" },
      { nome: "Descreve a avaria", preco: "Sob consulta" }
    ]
  },
  "galaxy-note-10-lite": {
    "Reparações disponíveis": [
      { nome: "Display/Touch", preco: "189,90€" },
      { nome: "Bateria", preco: "49,90€" },
      { nome: "Conector de Carga", preco: "49,90€" },
      { nome: "Câamera frontal", preco: "Sob consulta" },
      { nome: "Câamera Traseira", preco: "Sob consulta" },
      { nome: "Tampa Traseira", preco: "89,90€" },
      { nome: "Descreve a avaria", preco: "Sob consulta" }
    ]
  },
  "galaxy-note-9": {
    "Reparações disponíveis": [
      { nome: "Display/Touch", preco: "259,90€" },
      { nome: "Bateria", preco: "49,90€" },
      { nome: "Conector de Carga", preco: "89,90€" },
      { nome: "Câamera frontal", preco: "Sob consulta" },
      { nome: "Câamera Traseira", preco: "Sob consulta" },
      { nome: "Tampa Traseira", preco: "89,90€" },
      { nome: "Descreve a avaria", preco: "Sob consulta" }
    ]
  },
  "galaxy-m53": {
    "Reparações disponíveis": [
      { nome: "Display/Touch", preco: "129,90€" },
      { nome: "Bateria", preco: "Sob consulta" },
      { nome: "Conector de Carga", preco: "Sob consulta" },
      { nome: "Câmera frontal", preco: "Sob consulta" },
      { nome: "Câamera Traseira", preco: "Sob consulta" },
      { nome: "Tampa Traseira", preco: "Sob consulta" },
      { nome: "Descreve a avaria", preco: "Sob consulta" }
    ]
  },
  "galaxy-m13": {
    "Reparações disponíveis": [
      { nome: "Display/Touch", preco: "89,90€" },
      { nome: "Bateria", preco: "Sob consulta" },
      { nome: "Conector de Carga", preco: "Sob consulta" },
      { nome: "Câamera frontal", preco: "Sob consulta" },
      { nome: "Câamera Traseira", preco: "Sob consulta" },
      { nome: "Tampa Traseira", preco: "Sob consulta" },
      { nome: "Descreve a avaria", preco: "Sob consulta" }
    ]
  },
  "galaxy-m62": {
    "Reparações disponíveis": [
      { nome: "Display/Touch", preco: "159,90€" },
      { nome: "Bateria", preco: "Sob consulta" },
      { nome: "Conector de Carga", preco: "Sob consulta" },
      { nome: "Câamera frontal", preco: "Sob consulta" },
      { nome: "Câamera Traseira", preco: "Sob consulta" },
      { nome: "Tampa Traseira", preco: "Sob consulta" },
      { nome: "Descreve a avaria", preco: "Sob consulta" }
    ]
  },
  "galaxy-m52-5g": {
    "Reparações disponíveis": [
      { nome: "Display/Touch", preco: "119,90€" },
      { nome: "Bateria", preco: "Sob consulta" },
      { nome: "Conector de Carga", preco: "Sob consulta" },
      { nome: "Câamera frontal", preco: "Sob consulta" },
      { nome: "Câamera Traseira", preco: "Sob consulta" },
      { nome: "Tampa Traseira", preco: "Sob consulta" },
      { nome: "Descreve a avaria", preco: "Sob consulta" }
    ]
  },
  "galaxy-m32": {
    "Reparações disponíveis": []
  },
  "galaxy-m22": {
    "Reparações disponíveis": [
      { nome: "Display/Touch", preco: "89,90€" },
      { nome: "Bateria", preco: "Sob consulta" },
      { nome: "Conector de Carga", preco: "Sob consulta" },
      { nome: "Câamera frontal", preco: "Sob consulta" },
      { nome: "Câamera Traseira", preco: "Sob consulta" },
      { nome: "Tampa Traseira", preco: "Sob consulta" },
      { nome: "Descreve a avaria", preco: "Sob consulta" }
    ]
  },
  "galaxy-m12": {
    "Reparações disponíveis": [
      { nome: "Display/Touch", preco: "69,90€" },
      { nome: "Bateria", preco: "Sob consulta" },
      { nome: "Conector de Carga", preco: "Sob consulta" },
      { nome: "Câamera frontal", preco: "Sob consulta" },
      { nome: "Câamera Traseira", preco: "Sob consulta" },
      { nome: "Tampa Traseira", preco: "Sob consulta" },
      { nome: "Descreve a avaria", preco: "Sob consulta" }
    ]
  },
  "galaxy-m02s": {
    "Reparações disponíveis": []
  },
  "galaxy-m02": {
    "Reparações disponíveis": [
      { nome: "Display/Touch", preco: "49,90€" },
      { nome: "Bateria", preco: "Sob consulta" },
      { nome: "Conector de Carga", preco: "Sob consulta" },
      { nome: "Câamera frontal", preco: "Sob consulta" },
      { nome: "Câamera Traseira", preco: "Sob consulta" },
      { nome: "Tampa Traseira", preco: "Sob consulta" },
      { nome: "Descreve a avaria", preco: "Sob consulta" }
    ]
  },
  "galaxy-m51": {
    "Reparações disponíveis": [
      { nome: "Display/Touch", preco: "109,90€" },
      { nome: "Bateria", preco: "Sob consulta" },
      { nome: "Conector de Carga", preco: "Sob consulta" },
      { nome: "Câamera frontal", preco: "Sob consulta" },
      { nome: "Câamera Traseira", preco: "Sob consulta" },
      { nome: "Tampa Traseira", preco: "Sob consulta" },
      { nome: "Descreve a avaria", preco: "Sob consulta" }
    ]
  },
  "galaxy-m31s": {
    "Reparações disponíveis": [
      { nome: "Display/Touch", preco: "139,90€" },
      { nome: "Bateria", preco: "49,90€" },
      { nome: "Conector de Carga", preco: "39,90€" },
      { nome: "Câamera frontal", preco: "Sob consulta" },
      { nome: "Câamera Traseira", preco: "Sob consulta" },
      { nome: "Tampa Traseira", preco: "49,90€" },
      { nome: "Descreve a avaria", preco: "Sob consulta" }
    ]
  },
  "galaxy-m31": {
    "Reparações disponíveis": [
      { nome: "Display/Touch", preco: "89,90€" },
      { nome: "Bateria", preco: "Sob consulta" },
      { nome: "Conector de Carga", preco: "Sob consulta" },
      { nome: "Câamera frontal", preco: "Sob consulta" },
      { nome: "Câamera Traseira", preco: "49,90€" },
      { nome: "Tampa Traseira", preco: "Sob consulta" },
      { nome: "Descreve a avaria", preco: "Sob consulta" }
    ]
  },
  "galaxy-m21s": {
    "Reparações disponíveis": [
      { nome: "Display/Touch", preco: "89,90€" },
      { nome: "Bateria", preco: "Sob consulta" },
      { nome: "Conector de Carga", preco: "Sob consulta" },
      { nome: "Câamera frontal", preco: "Sob consulta" },
      { nome: "Câamera Traseira", preco: "Sob consulta" },
      { nome: "Tampa Traseira", preco: "Sob consulta" },
      { nome: "Descreve a avaria", preco: "Sob consulta" }
    ]
  },
  "galaxy-m21": {
    "Reparações disponíveis": [
      { nome: "Display/Touch", preco: "119,90€" },
      { nome: "Bateria", preco: "Sob consulta" },
      { nome: "Conector de Carga", preco: "Sob consulta" },
      { nome: "Câamera frontal", preco: "Sob consulta" },
      { nome: "Câamera Traseira", preco: "Sob consulta" },
      { nome: "Tampa Traseira", preco: "Sob consulta" },
      { nome: "Descreve a avaria", preco: "Sob consulta" }
    ]
  },
  "galaxy-m11": {
    "Reparações disponíveis": [
      { nome: "Display/Touch", preco: "64,90€" },
      { nome: "Bateria", preco: "Sob consulta" },
      { nome: "Conector de Carga", preco: "Sob consulta" },
      { nome: "Câamera frontal", preco: "Sob consulta" },
      { nome: "Câamera Traseira", preco: "Sob consulta" },
      { nome: "Tampa Traseira", preco: "Sob consulta" },
      { nome: "Descreve a avaria", preco: "Sob consulta" }
    ]
  },
  "galaxy-m01": {
    "Reparações disponíveis": [
      { nome: "Display/Touch", preco: "49,90€" },
      { nome: "Bateria", preco: "Sob consulta" },
      { nome: "Conector de Carga", preco: "Sob consulta" },
      { nome: "Câamera frontal", preco: "Sob consulta" },
      { nome: "Câamera Traseira", preco: "Sob consulta" },
      { nome: "Tampa Traseira", preco: "Sob consulta" },
      { nome: "Descreve a avaria", preco: "Sob consulta" }
    ]
  },
  "galaxy-m30s": {
    "Reparações disponíveis": [
      { nome: "Display/Touch", preco: "119,90€" },
      { nome: "Bateria", preco: "49,90€" },
      { nome: "Conector de Carga", preco: "Sob consulta" },
      { nome: "Câmera frontal", preco: "Sob consulta" },
      { nome: "Câamera Traseira", preco: "Sob consulta" },
      { nome: "Tampa Traseira", preco: "Sob consulta" },
      { nome: "Descreve a avaria", preco: "Sob consulta" }
    ]
  }
};


